// Generated from svg assets/Elderly care-13.svg so Remotion can animate real SVG layers.
export const elderlyCare13Elements = [
  {
    "type": "path",
    "attrs": {
      "d": "M101.6,698.5s4.1,21.5,2.8,25.8S95.7,739,81.7,738.6s-37.3-6.4-45.9-27-1.6-33.9,0-42.9,6.5-35.8,5.9-44.8,2-16.1,9.7-19.5,22.2-2.1,22.2-2.1,35.9,8.2,36.8,16.3S99.8,687.4,101.6,698.5Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M82.4,740.1h-.8c-16.5-.4-38.8-8-47.2-27.9-7.1-17.1-3.8-29.3-1.4-38.1.5-2.1,1-4,1.3-5.6,1.6-8.8,6.5-35.7,5.9-44.5-.6-10.5,2.9-17.6,10.6-21s22.3-2.3,23-2.2c6.3,1.4,37.1,8.9,38.1,17.6.4,3.7-1.6,17.1-3.8,32.7-2.8,19.3-6,41.1-5,47.1.4,2.4,4.1,22,2.8,26.5S96.6,740.1,82.4,740.1ZM67.5,603.5c-4.8,0-11.3.4-15.5,2.3-6.5,2.8-9.3,8.7-8.8,18s-4.3,36.3-5.9,45.2c-.3,1.8-.9,3.8-1.4,5.8-2.3,8.5-5.5,20,1.3,36.2C45,729.7,66,736.7,81.7,737.1c13.3.3,20.2-9.6,21.3-13.2s-1.3-16.9-2.9-25.1h0c-1-6.4,2-27.6,5-48,2.1-14.7,4.1-28.6,3.8-32s-21.2-11.7-35.6-15h0C73.2,603.7,70.8,603.5,67.5,603.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M729.3,425.6c.5-.6-11.9,10.4-18.3,12.4s-4.1-7.8-4.1-7.8-8.1,3.5-9.6-.1-2.9-3.9-2.9-3.9l-4.4-2.9V554.7s-11.3-.2-17.7,7.2S634.9,659,634.9,659l-19.4,65.3-66.2-12.1-85.7-35.9-8.7-9.6-12.8-4.6,41-131.8s4.1-5.8,7.9-6.6l3.8-.7,1.3-17.3,2-85.8h82.2s56.7-22.8,62-25.9,7.4-5.6,7.4-5.6,19.3-15.8,23.1-19.6,2.8-3,2.1-3-190.5,5.1-190.5,0c0-2.2-1.9,22.3-2.8,52.1-1.3,39.3-1.8,87-1.8,87s1,1.8-1.5,3-9.7,7.2-16.6,26.5-38.4,138.4-38.4,138.4l-52.9,36.8c-1.8,1.3-8.9,3.6-4,9.5S432,757.5,432,757.5L560.4,806s21.4,9.7,29.8,4.6,52.1-62.8,52.1-62.8,5.6-6.1,3.8-10.9-13.4-8.4-13.4-8.4l11.4-32.1,42.7-.5,1.3,30.8s-4.6-3.1-5.3,1.5,0,19.9,0,19.9,23.9,1.5,25.4,3,1-23.1,1-23.1l-5.3-3.1V697.2l47.8.2-8.2-18.3-37.6-.5V570.8h39.7l4.3-16.1-44.3.3V462.7H818.3s35.4-16.8,51.1-19.1,52.2,2.5,52.2,2.5l.4-20.5S728.7,426.1,729.3,425.6ZM688.4,577.9,687,678.1l-37.1.3,26.9-87.8s8.9-16.5,10.7-15.8S688.4,577.9,688.4,577.9Z",
      "fill": "#ddd2cc"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M710.2,111.2s-11,1-16.2-18a43,43,0,0,1-4.2-28.6c3.2-16.2,26.4-22,26.4-22s18.4-16.4,37.3-19.9,57.3,8.5,69,33.6,11,47.9,7.8,56.1-14.5,28.9-12.2,38.4l2.2,9.4s-8.5,4.3-16.7,3.5-11.2-4.2-11.2-4.2Z",
      "fill": "#ddd2cc"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M269,200.8c.2-.6,6.8-12.1-5.9-24.3s-25.1-32.1-27.9-50.3.7-33.4,8.7-44.3,23.8-23.8,32.4-24.2c.4.6,11-10.2,28.4-13s39.6,0,54.3,11.5,15.5,15.1,15.5,15.1,11.7,11.9,13.8,24.9,1.5,22.1-9.6,33.6-81.4,64.4-81.4,64.4Z",
      "fill": "#7b4e3d"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M246.3,215.5c.6,0,17.2-8.6,22.1-11.9s15.1-9.4,15.1-9.4,19.7-13.4,21.9-22.5a24,24,0,0,1-8.1-15.6c-.8-9.8.9-14.8,5.7-17.2s10.9-1.3,12.6,2.4,7.9,14,9.1,13.3,3.4-17.4,5.6-20.6S349,121,349,121s9.7,1.5,15.9-2.3,13.4-10,12.8-10.2,3.2,15.9,1.5,22.8-3.2,14.4-1.1,19.5,8.5,11.1,7.2,14.1-9.3,11.9-9.3,11.9-5.6,21.7-10.7,26.3-22.9,8.3-32.5,1.5c0,0-8.1,16.2-5.7,20S339,236.1,339,236.1s-9.2,8.5-27.5,10.8-33.6-6.8-44.6-11S246.3,215.5,246.3,215.5Z",
      "fill": "#fdcbac"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M244.8,216.3s-43.8,19.3-53.2,24.3-22.9,19.7-28.7,32.5-24.2,65-27.2,88.4-15.9,109.5-20,121.4c-2.1,5.9-4.1,18.1-7.6,27.9s-8.4,17.4-8.7,20.2c-.5,5.5-2.4,21,0,21.2s37.1,7.1,78-1.6,82.3-32.6,89.9-39.2,20.6-17.4,32.3-22.1,30.9-7.2,30.9-7.2L332,470V409.8l51.3-14.7s13-7.4,18.1-16.8,6.6-10.6,5.9-15.1-7.6-12.9-9.5-27.4-12.6-60.8-15.1-67.4-13-14.2-18.8-17.9-22.5-13.1-23.1-12.9-18.9,10.2-38.1,8.7-40.8-10.4-46.3-17.7S246,216.9,244.8,216.3Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M219,435.4s22.3,40.9,49.9,48.2,115.4-34.4,115.4-34.4,59.9-23.8,66.2-26.6,20.1-2.5,31.4-19.3,25.3-28.3,26.8-32.8a7.9,7.9,0,0,0-1.3-7.6l28.4-3.2s-13.3,11.8-11.5,18.3,4.5,6.8,10,3.5,9-9,15.8-12,17.3-2.3,18.5-7.3-1-24.6-3-28.6-8.5-6.5-8.5-6.5l-11.8.2S530.5,316,513.5,315s-33.6,1.3-41.4,8.6-47.4,45.1-53.7,61.2l-11.8,3-4-14.3s-10,18-13.8,20c0,0-89.6,22.1-97.8,28.6,0,0-16.3-28.3-20.4-27.8S222.7,426.9,219,435.4Z",
      "fill": "#fdcbac"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M420.1,517c-4.5-25.2-17.6-37.9-34.2-39.7s-83.5,10.4-83.5,10.4-44.5,25.9-57.3,36.6-45.9,21.7-62.4,24.1-45.9,9.7-77.7,3.8c0,0,6.3,51.4,14.5,66.2a45.7,45.7,0,0,0-11,2.1c-4.5,1.7-13.8,4.2-16.2,16.9s-4.2,47.6,3.1,55.2,40.7,31.8,40.7,31.8,67.6,45.2,85.9,50.4,46.6,5.8,56.9-2.5,17.3-19.3,18.3-24.1,1.8-23.1-.7-28.7-8.9-22-8.9-22S309.3,712.6,330,713s40-1.4,41.4-5.9,38.3-128.3,38.3-128.3S424.6,542.2,420.1,517ZM285.5,689.9,253.1,587.4c6.5,3.8,63.8,2.8,63.8,2.8Z",
      "fill": "#fad097"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M295.7,750.5s11.8,9.1,26.5,13.2,55.2,15.3,61.5,15.6,19.7,1.8,24.5-6.1a24.4,24.4,0,0,0,3.1-19.7c-1.3-4.8-4-13.2-19.5-18.4s-30.5-10.6-31.4-15.5-1.4-8-1.4-8-45.4,4.1-64.7-9.9c0,0-4.3-4.1-4.7.4s8.2,18.1,8.2,25.1S295.7,750.5,295.7,750.5Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M670.8,425.2s-22.6-20.4-23.3-25.8-.9-7.3-.9-7.3l-36.8,13.4s-64,30.4-78.3,41.5-27.6,36.3-36.7,67.8-32.2,136.8-33.4,141.1c0,0-4.9,8.9-3.1,12.1s6.1,10.5,27,16c27.5,7.3,45.6,1.9,45.6,1.9l-4.3,12.9s5.2,10.2,29.7,15.4,46.9-3.4,48.5-6.8,38.8-137,38.8-137,10-29,16.1-33.8,9.5-6.1,15.7-5.7c1.4.1,5,2.7,14,3.3l.3-96.2C672.8,432.8,670.8,425.2,670.8,425.2Z",
      "fill": "#a2d6f5"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M848.2,464.5c-5.1-4.6-109.3,1.1-141.7-3.4l-1.4,74.5c33,2.2,82.6,3.6,94.9,3.9,17.9.5,42.9-14.7,49.7-27.5S853.6,469.5,848.2,464.5Z",
      "fill": "#a2d6f5"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M560.2,326.7c-.9.1,4.8-4.3,9.8-5.4s54.2-11.8,54.2-11.8,25.4-60.4,28.1-67.6,25-42.9,42.5-54.7,23.5-12.9,28.5-13.2l7.8-.2s4.3,11.8,16.3,15.7,34.5,3.6,48.5-3.2,17-13.6,17-13.6,6.9-.3,13.9,5.4,27,21.6,36.3,42.7,31.1,83.7,32,96.6,6.1,44.2.2,56-29.9,26.6-37.7,29.1-68.7,11.1-78,11.1-22.5,3.8-23.8,1.6S744.2,385,739.2,378s-3.2-3.2-4.5-3.4-20.9,7.5-26.1,10.4-24.1,23.8-23.8,27.5,2.7,7.7,2.7,7.7l2.5,3.1-1.4,13.9s-21.3-9.1-31.5-25.7-13.8-14.7-10.7-18.6,19.1-16.5,23.6-21.1,11.1-14.2,12.3-17.6.4-14.6.4-14.6-18.6,15.7-33.8,19.5-55.8,12.1-55.8,12.1-16.3,5.2-20.6-2.3-3.2-22-3.9-26.1S562.9,326.5,560.2,326.7Z",
      "fill": "#fef7d1"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M731.1,173.8s7.6.6,9.7-.3,2-5.2,2-5.2-12.9-.6-17.6-5.9-13.1-22.4-13.6-23.9-9.8-1.1-8.9-5.1,7.4-13.2,7.7-15.6-2.2-14.8-2-25.1,3.5-17.4,7.6-21.1,11.3-3.2,12.9,1.3,13.3,22,21.1,24.8,13.5,4.8,15,7.9,4.2,9.1,6.6,7.6,3.9-13.5,8.4-14.6,9.8,4.4,10.9,7.9-3,18.5-3,18.5l-1.6,3.5s5.7,30.7,9.2,34.8,9.4,8.9,13.1,9.3,4.8-.4,3.7,2.5-12.9,12.6-30.3,15.4S739.8,193.9,731.1,173.8Z",
      "fill": "#fdcbac"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M734.7,374.6c-.1,0-23.2,6.9-25.9,8.9s-20,19.4-21.4,25-5.2,8.4.1,11.7l3.5.2s-.1,5.2,3.4,5.8,3.2-.2,3.2-.2-1,5.5,2.9,5.8a9.6,9.6,0,0,0,6.4-1.6s-4.3,4.3,1,6.6,9.8-2,12.6-4.4l15.9-13.5s15.9-2.6,17.6-6.2C754,412.7,743.2,376.5,734.7,374.6Z",
      "fill": "#fdcbac"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M868.8,237.2c2,0,56.5,4.5,57.3,5.7s11.7,2,12.5,18.1-.8,141.2-.8,141.2,6.8-.4,8.4,7.7,2.4,7.2-.8,12.5-7.2,2.8-7.2,2.8-2.9,26.2-.8,26.6L922.8,449l-.8-23.4H729.3s-1.5-4.2,7.1-6.7a149.3,149.3,0,0,0,15-5.4s4.5,4,7.3,2.8,78.2-8.1,85.5-10.9,10.9-2.8,10.9-2.8S893,390.5,897,364.7s-4-56.9-6-62.5S868.8,237.2,868.8,237.2Z",
      "fill": "#ddd2cc"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M557.5,715.4s6.8,10.8,14.1,11.3,24.4-7.6,24.4-7.6l-.6-5.3Z",
      "fill": "#fdcbac"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M330.6,203.3c-2.1,4.8-4.1,9.6-5,14.7a51.7,51.7,0,0,0,.5,17.1c.3,1.9,3.2,1.1,2.9-.8a45.3,45.3,0,0,1-.4-16,62.1,62.1,0,0,1,4.5-13.4c.8-1.8-1.7-3.3-2.5-1.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M271.5,198.9c-28.4,23.2-68.4,25.9-95.1,51.6-11.4,11-17.5,26-22.9,40.5-11.2,30.4-17.7,62.1-22.5,94.1-5,33.5-10,67.1-17.7,100.1-2.2,9.5-4.6,19.1-8.2,28.3-2.2,5.6-5.1,10.9-6.7,16.8a50.2,50.2,0,0,0-1.5,18.9,26.5,26.5,0,0,0,.6,3,1.4,1.4,0,0,0,1,1.1,134.8,134.8,0,0,0,22,2.6,215.6,215.6,0,0,0,53.2-3.3c22.5-4.2,43.9-12.5,64.2-22.8a289.3,289.3,0,0,0,38.2-23.7c8.6-6.2,17.3-12.6,27.2-16.6l3.9-1.4c1.8-.6,1-3.5-.8-2.9-10.2,3.4-19,9.1-27.6,15.3-11.2,8.1-22.4,15.9-34.6,22.6-19.4,10.7-40.2,19.5-61.9,24.6a216,216,0,0,1-56.1,5.5c-8.9-.3-18.1-.9-26.9-2.8l1.1,1.1a32.8,32.8,0,0,1-.7-10.8c.6-8,3.3-15.1,6.6-22.3s6-16.6,8.1-25.1c7.8-30.7,12.5-62.1,17.3-93.3,3.1-19.7,5.9-39.4,10.3-58.9a429.7,429.7,0,0,1,11.7-41.7,246.8,246.8,0,0,1,9.2-23.4,85.1,85.1,0,0,1,8.1-14.8c9.9-13.8,25.3-22.6,40.6-29.4,16.9-7.6,34.9-13.1,50.8-22.9a107.8,107.8,0,0,0,11.2-7.9c1.5-1.2-.7-3.3-2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M161.4,304.5c1.8,24.2,3.7,48.5,8.9,72.2,4.6,21.1,12.1,41.9,24,60.1,2,3.1,4,6.6,6.6,9.2s5.5,3.4,8.2,1.1a39.7,39.7,0,0,0,2.8-3l4-4c9-8.8,18.2-17.4,27.8-25.6,4.8-4.2,9.7-8.3,14.8-12.1,3.3-2.5,7-5.4,10.8-6.8l.9-.3h.6c1.9-.2,1.9-3.2,0-3-3.5.3-6.7,2.7-9.5,4.5-4.7,3.2-9.1,6.8-13.5,10.4-10,8.3-19.6,17-29,26-3.1,3-6.2,5.9-9.1,9-.8.9-1.9,2.5-3,3s-4.3-2-5.4-3.4c-12.8-17.3-21.1-37.5-26.3-58.2-6.6-25.8-8.6-52.5-10.6-79-.2-1.9-3.2-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M247.5,295.4a427.7,427.7,0,0,0,22.6,80.1c2.8,7.2,6.1,14.6,5.2,22.5-.2,1.9,2.8,1.9,3,0,.8-6.8-1.4-13.4-3.9-19.7s-5-13-7.3-19.6a407.7,407.7,0,0,1-11.8-40.5c-1.9-7.8-3.5-15.7-4.9-23.6-.4-1.9-3.3-1.1-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M356.3,303.2A377.5,377.5,0,0,0,333.7,386c-1.2,7.7-2.2,15.4-2.9,23.2-.2,1.9,2.8,1.9,3,0A377.5,377.5,0,0,1,351,326.4c2.5-7.6,5.2-15,8.2-22.4.7-1.8-2.1-2.6-2.9-.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M325.8,225.8c6.6,8.3,15.5,14.3,24.5,19.7l13.9,8c4.9,2.9,9.8,6,13.3,10.6,6.8,8.9,8.5,20.4,10.5,31.1,2.4,12.5,4.9,25,7.7,37.4,1.3,6,2.7,11.9,4.3,17.8,1,3.6,1.9,7.6,3.8,10.8.9,1.5,1.5,2.2,1.3,4s-1.7,5.8-3,8.4c-3.2,5.9-7.5,12.1-12.9,16.2a7.9,7.9,0,0,1-2.5,1.5c-1.8.6-1,3.5.8,2.9a18.4,18.4,0,0,0,6.4-4.6,60.8,60.8,0,0,0,6.9-8.3,50.8,50.8,0,0,0,5.5-9.6c1.1-2.5,2.1-5.3,1.8-8.1a6.3,6.3,0,0,0-1.2-3.2c-.4-.5,0,.1-.3-.3l-.4-.8a26.3,26.3,0,0,1-1.7-4.5c-1.7-5.2-3.1-10.7-4.3-16.1-3.1-13.1-5.8-26.4-8.4-39.6-1.9-9.9-3.3-19.6-7.4-28.9a34.6,34.6,0,0,0-9.5-13.1c-4.3-3.6-9.3-6.2-14.1-9-9.6-5.5-19.5-11-27.6-18.6a49.6,49.6,0,0,1-5.3-5.9c-1.2-1.5-3.3.7-2.1,2.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M279.4,483.8a167.9,167.9,0,0,1-56.6,22.3c-17.4,3.4-35.2,4.1-52.9,3.9-9.4-.1-18.9-.5-28.4-.6a1.5,1.5,0,0,0,0,3c17.4.2,34.7,1.1,52.1.2s37.1-4,54.6-10.3a173.3,173.3,0,0,0,32.7-15.9,1.5,1.5,0,0,0-1.5-2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M626.4,309.6c1.6-2.3,2.5-5.2,3.6-7.7,2.1-4.9,4.1-9.7,6-14.6,4-9.8,8-19.5,11.6-29.4a172.1,172.1,0,0,1,40.4-64c6.4-6.4,13.7-12.1,22.1-15.7a44.2,44.2,0,0,1,14.4-3.6,60.3,60.3,0,0,1,8.5.2c2,.1,4.1.4,6.2.4a6.8,6.8,0,0,0,4.7-2.1c1.3-1.8,1-4,.5-6s-3.4-1-2.9.8.7,2.3.1,3.2a3.6,3.6,0,0,1-2.4,1.1h-1.9l-6.7-.4a46.2,46.2,0,0,0-21.4,3.7c-15.9,6.7-28.2,20.4-38.5,33.8a169.3,169.3,0,0,0-24.4,43.5c-3.7,9.8-7.4,19.5-11.3,29.2-2.3,5.8-4.7,11.5-7.1,17.2-1.2,3-2.3,6.3-4,9s1.5,3.1,2.5,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M693,218.5c3.5,11.8,1,24-2.4,35.5s-7.5,22.3-8.8,34.1a117.1,117.1,0,0,0-.4,18.7c.2,5.4.9,10.6,1.1,16a119.4,119.4,0,0,1-.5,14.6c-.7,7.7-1.7,16.1-5.2,23.1s-10.9,13-17.4,18.1c-3.1,2.5-6.2,4.9-9.1,7.6s-4.2,4.1-4.8,6.8c-1.6,5.9,4,12.3,7.5,16.5,4.8,5.7,10.4,10.8,15.5,16.2a47.2,47.2,0,0,0,18.9,12.4l1.6.6c1.8.6,2.6-2.3.8-2.9a43.3,43.3,0,0,1-16.2-9.1c-2.6-2.3-4.8-4.9-7.2-7.3s-5.4-5.5-8-8.3a71,71,0,0,1-7.3-9.1c-1.4-2.1-3.1-4.9-2.9-7.6s2.7-4.6,4.4-6.2a107.2,107.2,0,0,1,9-7.4c6.3-5.1,13.2-10.4,17.2-17.6s5-14.8,5.8-22.4a124.6,124.6,0,0,0,.9-17.3c0-3.5-.5-7-.8-10.5-.4-6-.6-12-.4-18,.5-12.2,4-23.4,7.6-34.9s6.7-22.5,5.6-34.2a45.7,45.7,0,0,0-1.6-8.2c-.5-1.8-3.4-1-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M678,381.4c6,2.1,12.1,0,17.9-1.8s12.5-4,18.7-6.2c12.4-4.3,24.6-9.1,36.7-14.3,1.8-.7.2-3.3-1.5-2.5-11.6,4.9-23.4,9.5-35.4,13.7-5.8,2.1-11.7,4-17.6,5.9s-12,4.4-18,2.3c-1.8-.6-2.6,2.3-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M747.8,211.3a132.9,132.9,0,0,0,42.6-3.4c1.8-.4,1-3.3-.8-2.9a130.8,130.8,0,0,1-41.8,3.3c-1.9-.2-1.9,2.8,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M810.5,256.3c3,27.7,6.2,55.4,12.4,82.6.4,1.9,3.3,1.1,2.9-.8-6.2-26.9-9.3-54.3-12.3-81.8-.2-1.9-3.2-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M644.3,315.5a21.8,21.8,0,0,0-17.9-6.6c-5,.4-10,1.4-15,2.2l-17,3a223.7,223.7,0,0,0-24.2,5.7,30.5,30.5,0,0,0-7.5,3.1c-1.8,1.1-4.2,3.8-2.9,6.1a10.9,10.9,0,0,0,2.5,2.3,11.8,11.8,0,0,1,3.2,5.5c1.8,6.3,1.6,13.1,2,19.6.4,4.7.6,10.8,3.6,14.7,1.4,1.9,3.9,2.2,6.1,2.4,8.2.7,16.8-1.1,24.7-2.5q16.4-3.2,32.4-7.5c11.1-2.9,22.3-5.9,32.6-11,6.1-2.9,12.1-6.7,16.7-11.7l1-1.1a1.5,1.5,0,1,0-2.1-2.1,60.3,60.3,0,0,1-10.2,8.6c-9.2,5.7-19.5,9-29.9,12s-20.1,5.4-30.3,7.6-18.3,3.9-27.6,4.6a28.2,28.2,0,0,1-8.7-.1,5.2,5.2,0,0,1-2.1-.7,6.8,6.8,0,0,1-.9-1.4,25.3,25.3,0,0,1-1.2-3.6c-1.4-5.7-1.2-11.6-1.6-17.4s-.6-11.4-3.7-15.8a15.7,15.7,0,0,0-3.1-3.2l-.8-.7h0l.3-.5c1.2-1.8,2.8-2.5,4.9-3.3,6.8-2.5,14.2-4,21.3-5.5s13.6-2.7,20.4-3.8l3.5-.6,10.4-1.6a24.6,24.6,0,0,1,10.8.2,19,19,0,0,1,8.2,5.1c1.3,1.4,3.4-.7,2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M647.4,389.9c-16,6.1-32,12.4-47.8,19.3-17.8,7.8-35.4,16.3-51.8,26.8a159.1,159.1,0,0,0-20.5,15.4,134.6,134.6,0,0,0-14.6,16.5,101.9,101.9,0,0,0-12.9,22.4c-3.4,8.2-5.1,16.6-6.7,25.3-1.8,10.7-4.2,21.2-6.6,31.7-3.3,14.5-6.7,29-10.2,43.4s-7,28.1-10.7,42.1c-2.4,9.3-4.8,18.7-7.8,27.9-.4,1.1-.7,2.1-1.2,3.2v.2l-.4.9a5.6,5.6,0,0,0-.2,3.8c.8,3.1,3.6,5.3,6.1,6.9a60.6,60.6,0,0,0,12.6,6c11,4.1,22.9,7.3,34.5,8.3,6.5.6,13.6.6,19.8-1.7l2.4-1.1c1.6-1,.1-3.6-1.5-2.6s-6.3,2.2-9.4,2.5c-10.2,1-20.5-1.2-30.4-3.8a131.8,131.8,0,0,1-16.5-5.2c-4.1-1.6-8.3-3.4-11.7-6.2s-3.8-3.5-2.8-6c.3-.9.7-1.7,1-2.6,2.9-8,4.9-16.2,7.1-24.3,3.5-13.3,6.9-26.5,10.1-39.8s7-28.7,10.4-43.1c2.6-11.5,5.2-22.9,7.5-34.5,1-5.5,1.7-11.1,3-16.5a95.9,95.9,0,0,1,11-26.7A120.4,120.4,0,0,1,540,444.9c15.1-11,31.8-19.6,48.6-27.5s32.9-14.3,49.6-20.8l10-3.8c1.8-.7,1-3.6-.8-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M688,531.5a67.8,67.8,0,0,0-12.8-1.5c-5.7-.1-10.9.8-15.1,4.9s-6.8,10-9.4,15.3-4.2,8.3-5.9,12.7c-2.3,6.1-4.1,12.4-6,18.6-2.9,9.5-5.6,19.1-8.3,28.6q-8.8,31.8-17.5,63.5c-2.1,8-4.3,15.9-6.5,23.9l-2.1,7.2c-.3.8-.5,1.6-.8,2.3a1.4,1.4,0,0,1-.2.7c-.2.5.1.1-.1.2s.9-.5.3-.3l-1.1.7a23.8,23.8,0,0,1-3.9,2,55,55,0,0,1-16.5,3.8,99,99,0,0,1-27.7-1.4c-7.1-1.3-14.4-3.3-20.5-7.2-2.9-1.9-6.4-4.8-4.8-8.5a59,59,0,0,0,2-7.2c2-9.1,3.5-18.3,5-27.5,3-18,5.6-36.2,8.2-54.3,1.7-12.2,4-24.4,5.9-36.5,2.3-15.1,4.5-30.2,7.8-45,2.2-10.1,5-20.6,10.7-29.4,2.3-3.6,5.4-6.6,8.3-9.7A181.3,181.3,0,0,1,591.3,474c12.1-9.9,25.6-17.8,39.4-24.9,11.3-5.8,22.7-11.2,34.4-16.2l4.7-1.9,1.3-.5h.7c-.7.5-1.6-2.3-1.7-1.4s2.8,1.9,3,0-5.3-.3-6.3.1c-4.8,1.9-9.5,4-14.1,6.2-12.9,5.9-25.7,12.1-37.9,19.1a177,177,0,0,0-37.2,28.2,108.9,108.9,0,0,0-9.8,10.6,57.5,57.5,0,0,0-6.6,11.9c-4.6,11.3-6.9,23.6-9.1,35.6-3,17.1-5.4,34.4-8.3,51.5s-5.1,33.9-7.7,50.9c-1.6,10.9-3.3,21.7-5.3,32.6-.7,4.2-1.5,8.3-2.4,12.5a39.6,39.6,0,0,1-2,7.5v.2a5.8,5.8,0,0,0-.5,1.4,6.1,6.1,0,0,0-.1,3,10.2,10.2,0,0,0,3.2,5.2c4.6,4.4,11.2,6.8,17.2,8.5a104.5,104.5,0,0,0,27.8,3.6,73.6,73.6,0,0,0,20.9-2.7,36.5,36.5,0,0,0,9.7-4.2,4.4,4.4,0,0,0,2-2.7c1.7-4.9,2.9-10,4.3-15,5.5-19.7,10.8-39.5,16.3-59.2s10.8-39.4,16.9-58.8a126.2,126.2,0,0,1,6.4-17.3c3-6.2,5.7-13.1,10-18.6a17,17,0,0,1,5.4-4.6c2.7-1.3,6-1.4,9-1.4a57.5,57.5,0,0,1,12.4,1.4c1.9.4,2.7-2.5.8-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M542.9,696.2c9.1-4,17.3-10.4,24.8-16.8a231.7,231.7,0,0,0,30.9-32.5,273.5,273.5,0,0,0,16.9-24.1c1-1.6-1.6-3.1-2.6-1.5A254.7,254.7,0,0,1,582.5,661a181.8,181.8,0,0,1-28.6,25.4,82.7,82.7,0,0,1-12.6,7.3c-1.7.7-.2,3.3,1.6,2.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M476,662.1c9.9,1.8,18.9-2.8,26.4-8.8s16.5-14.5,24.7-21.7c1.4-1.3-.7-3.4-2.1-2.2-7.5,6.7-14.9,13.6-22.6,20.1s-15.9,11.4-25.6,9.7c-1.9-.3-2.7,2.5-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M270.3,393.7h-.1l1.7-.7.8.7-.2,1.2h.1l-1.3.7c-.3,0,.7,1.2.8,1.4l1.4,1.9,2.4,3.4,4.6,6.5c3.1,4.5,6.3,9.1,9.6,13.5,1.1,1.6,3.7.1,2.6-1.5-4.3-5.8-8.4-11.8-12.6-17.7-2.1-3-4.2-6-6.4-8.9-.7-1-2.1-2.4-3.4-1.2a1.8,1.8,0,0,0,.8,3,1.5,1.5,0,0,0,1.7-.7h.1c.9-1.7-1.7-3.2-2.6-1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M280.3,427.4c14.7-5,29.5-9.6,44.4-14.1,19.4-5.9,39-11.7,58.6-17,9-2.5,18-4.9,27.1-7.1l11.6-2.8,5.3-1.2c1.4-.2,3-.2,4-1.3,3.1-3.4,5.7-7.5,8.4-11.2,4.2-5.9,8.2-12.1,13.4-17.3a49.1,49.1,0,0,1,16-10.6c6.3-2.6,12.9-3.3,19.6-3.9,3.3-.2,8.9-1.5,11.9.6s-3.2,5.4-5.6,5.8c-8.3,1.5-16.7,3-23.9,7.8a23.4,23.4,0,0,0-5.6,4.8c-1.3,1.4.8,3.6,2.1,2.1,6.6-7.3,16.4-9.8,25.7-11.4,3.3-.5,6.5-1.1,9.3-3.2s1.8-8-2.4-9.3-8.6-.4-12.8-.1c-6.8.6-13.5,1.5-19.9,4.2a51.9,51.9,0,0,0-15.8,10.5c-5.3,5-9.3,11.1-13.5,16.9-2.1,3-4.2,6-6.4,8.9a28.8,28.8,0,0,1-2.7,3.4c-.4.3.5,0-.2,0s-.7.1-1.1.2l-2.7.6-5.5,1.2c-8.8,2-17.4,4.2-26.1,6.5-20.3,5.4-40.4,11.2-60.5,17.2-16.5,5-33.1,10.1-49.5,15.6l-4,1.4c-1.8.6-1,3.5.8,2.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M341.7,403.3a93.7,93.7,0,0,1,15.5-33.8c1.2-1.6-1.4-3.1-2.5-1.5a94.4,94.4,0,0,0-15.9,34.5c-.4,1.9,2.5,2.7,2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M338.3,237c-13,5.4-26.4,10.1-40.6,7.9-7.4-1.2-14.4-3.7-21.3-6.4s-12.4-5.6-17.5-10.2a35.5,35.5,0,0,1-4.7-4.8c-.6-.8-1-1.7-1.5-2.5s-3.1-5.1-5.8-5.8a1.5,1.5,0,0,0-.8,2.9c2.3.6,3.7,3.8,4.8,5.7a30.4,30.4,0,0,0,6.1,6.8,61.4,61.4,0,0,0,17.2,10.3c13,5.2,26.5,9.1,40.5,6.8,8.4-1.4,16.5-4.5,24.4-7.8,1.7-.7.9-3.6-.8-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M280.4,258.1a162.2,162.2,0,0,0,37.5-.2c1.9-.3,1.9-3.3,0-3a167.9,167.9,0,0,1-37.5.3c-1.9-.3-1.9,2.7,0,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M103.6,553.3A241.5,241.5,0,0,0,136,655.4a245.8,245.8,0,0,0,17,25.1c1.2,1.5,3.3-.7,2.1-2.2A237.5,237.5,0,0,1,111,583.2a253.6,253.6,0,0,1-4.4-29.9c-.1-1.9-3.1-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M238,551.4c12.8,24.9,19.8,52.5,27.9,79.2l12.7,41.7,6.3,20.8,3.2,10.7a50.5,50.5,0,0,0,1.8,5.5,61.5,61.5,0,0,1,5.9,18.8,48.3,48.3,0,0,1-8.5,34.4c-5.5,7.6-13.6,12.1-22.8,13.7s-19.3.4-28.8-.6a55.7,55.7,0,0,1-14.4-3.3,153.6,153.6,0,0,1-16.4-7.7c-14.1-7.4-27.8-15.7-41.2-24.2s-26.9-17.6-40-26.9c-8.5-6-17.2-11.9-24.9-18.8-4.1-3.7-5.8-8.7-6.9-13.9-1.6-8.2-1.5-16.8-.8-25.1s2-15.8,5-22.9A20.8,20.8,0,0,1,114.4,620a18.1,18.1,0,0,1,5.7.5,1.5,1.5,0,0,0,.8-2.9c-6.5-1.8-14.3.1-19.7,4s-8.7,10.9-10.5,18a112.6,112.6,0,0,0-3.1,25.9c0,7.9.6,16.4,3.7,23.7,1.8,4.2,4.6,7,8,9.8s8.1,6.4,12.3,9.5c12.5,9.2,25.3,17.9,38.2,26.5s28.8,18.5,43.8,26.9c6.2,3.4,12.4,6.8,18.9,9.8a86.6,86.6,0,0,0,14.6,5.7,65.7,65.7,0,0,0,8.9,1.2c5.1.5,10.3,1.1,15.5,1.2,9.1.3,18.6-.6,26.8-5.2s15.9-15.3,18.9-25.6,2.4-21.9-1-32.3a62.5,62.5,0,0,0-3.3-8.1,6.6,6.6,0,0,1-.8-2.1c-1.1-3.7-2.3-7.3-3.4-11l-13.1-43.2-13.2-43.6c-4.1-13.5-8.2-27.1-13.5-40.3-2.5-6.3-5.2-12.5-8.3-18.5-.9-1.7-3.5-.2-2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M252.6,586.2c1.4,2.1,4.2,2.3,6.5,2.7s4.9.8,7.4,1c5.6.6,11.3.9,16.9,1.2,11.3.4,22.6.3,33.9.6a1.5,1.5,0,0,0,0-3c-10.5-.3-20.9-.2-31.4-.5-5.3-.2-10.7-.5-16-.9-2.5-.3-5-.5-7.4-.9l-3.6-.5c-1.1-.2-3.1-.3-3.7-1.2s-3.7-.1-2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M338.6,522.5c-5.4,9.4-8.9,19.6-12.1,29.9s-6.7,22.2-10.1,33.4q-9.9,32.9-19.9,65.7l-11.4,37.9c-.6,1.8,2.3,2.6,2.9.8q20-66.3,40.1-132.5c3.4-11.5,7-23.2,13.1-33.6a1.5,1.5,0,0,0-2.6-1.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M286.1,697.6c12.8,10,28.6,15,44.6,16.3a105.2,105.2,0,0,0,21-.2,66.3,66.3,0,0,0,15.3-3.3c2.4-.9,6-2.1,6.8-4.9s1.4-6.2,2.2-9.2c3.6-14.2,7.5-28.3,11.6-42.4s8.9-28.9,14-43.2c5.7-16,11.2-32,15.3-48.5,6.6-26.4,12.6-64.8-16.5-80.2a52.8,52.8,0,0,0-24-5.8,272.4,272.4,0,0,0-55.5,5.8c-5.5,1.1-11,2.4-16.4,3.9a1.5,1.5,0,0,0,.7,2.9,283.1,283.1,0,0,1,67.2-9.6,58.2,58.2,0,0,1,19.4,2.5c11.7,3.7,21,12.2,24.9,24,4.8,14.5,2.6,30.9-.4,45.5-6.1,30.5-18.6,59.2-27.6,88.8-4.6,14.9-8.8,30-12.9,45-1.3,5.1-2.7,10.2-4,15.4-.3,1.2-.6,2.5-.8,3.8s-.2.8-.1.6l-.6.7c-2.8,2.1-6.8,3-10.1,3.7a84.3,84.3,0,0,1-18,2.1c-15,.3-30.4-2.3-43.8-9.3a61.3,61.3,0,0,1-10.2-6.6c-1.5-1.1-3.6,1-2.1,2.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M329.1,470.3c-.1,3.9-.1,7.9-.2,11.8a1.4,1.4,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5c.1-3.9,0-7.9.2-11.8a1.5,1.5,0,0,0-1.5-1.5,1.5,1.5,0,0,0-1.5,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M495.2,390.1c.5,30.4.2,60.9-.5,91.3-.2,7.8-.4,15.5-.7,23.3-.1,1.9,2.9,1.9,3,0,1.2-30.4,1.5-60.9,1.4-91.3,0-7.7-.1-15.5-.2-23.3a1.5,1.5,0,0,0-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M480,406l-.4,33.9-.7,53.7v12.3a1.5,1.5,0,1,0,3,0l.4-33.9.6-53.7L483,406a1.5,1.5,0,0,0-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M497.6,420.5h81.5a1.5,1.5,0,0,0,0-3H497.6a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M495.1,390.8H648a1.5,1.5,0,0,0,0-3H495.1a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M854.2,404.4H941a3.4,3.4,0,0,1,3.1,2,12,12,0,0,1,.8,5.3l.3,5.5c.1,2.2.2,4.9-2.2,5.9s-3.6.6-5.4.6H728.9a1.5,1.5,0,0,0,0,3H938.3a16.8,16.8,0,0,0,5.9-.8c2.5-1,3.6-3.2,3.9-5.9s0-7.1-.2-10.5-1.2-6-4-7.5-4.5-.6-6.7-.6h-83a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M689.3,421.6c-.8,3.7-.7,7.8-.9,11.6,0,1.9-.1,3.7-.1,5.6l-.3,20.5c-.1,10.1-.1,20.2-.2,30.2l-.3,37.4c-.1,13.7-.2,27.4-.2,41.1l-.3,41.7-.3,39.6c0,11.4-.1,22.8-.2,34.2l-.3,25.8c0,4.7-.1,9.4-.2,14.2a6.1,6.1,0,0,0-.1,1.4c-.1,1.9,2.9,1.9,3,0,.2-3.6.2-7.3.2-10.9.2-7.8.2-15.5.3-23.2l.3-32.3c.1-12.8.1-25.7.2-38.5l.3-41.4.3-41.5c0-12.8.1-25.6.2-38.4l.3-32.5c0-7.7.1-15.5.2-23.2.1-3.7.1-7.4.3-11.1s0-6.5.6-9.5-2.4-2.7-2.8-.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M939.2,402.2V264.1a44.6,44.6,0,0,0-.4-8.2c-1.2-6.8-5-12.2-11.8-14.1a147.3,147.3,0,0,0-18.6-3.1c-12.1-1.5-24.4-3-36.6-3.6h-.7c-1.9-.1-1.9,2.9,0,3,10.2.8,20.4,1.7,30.6,2.9,6.8.8,13.7,1.6,20.4,2.9,2.5.5,5.1.9,7.3,2.1a13.5,13.5,0,0,1,5.9,8.1,30.4,30.4,0,0,1,.9,9.5V402.2a1.5,1.5,0,0,0,3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M707.1,556.6H885.8c1.9,0,3.8.1,5.6,0h.4l1.5.2c15.6,1.5,33.4-3.5,41.2-18.3,6.1-11.5,4.7-25.3,4.7-37.9v-75a1.5,1.5,0,0,0-3,0v84.8c0,6.5.2,12.9-1.4,19.1a30.5,30.5,0,0,1-19.3,21.6,51,51,0,0,1-20.5,2.8l-2.3-.2c-.8-.1.5,0-.6,0s-2.4,0-3.6,0H707.1a1.5,1.5,0,1,0,0,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M688.5,553.7a21.2,21.2,0,0,0-14.6,5.4,32.8,32.8,0,0,0-7.2,10.5c-4.6,9.7-8.7,19.6-12.4,29.6-10.1,27-18.5,54.6-27.2,82l-7.8,24.5c-1.9,5.7-3.5,11.4-6,16.8-.8,1.8,1.8,3.3,2.6,1.6a122.3,122.3,0,0,0,4.8-13.2c2.3-7,4.5-13.9,6.7-20.9l13.5-42.5c7.8-24.1,15.5-48.6,26.2-71.7,1.8-4,3.6-8.3,6.3-11.8a18.6,18.6,0,0,1,15.1-7.4c1.9,0,1.9-3,0-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M710,74.9a58.5,58.5,0,0,0-2.6,36.5,18.2,18.2,0,0,1,.8,5.2,10.6,10.6,0,0,1-1.6,4.3,63.6,63.6,0,0,0-4.3,7.7c-.9,2.1-2.1,5,0,7a13.9,13.9,0,0,0,3.6,2L711,140l-.7-.9a79.2,79.2,0,0,0,9.2,18.4c2.4,3.5,5.3,7.1,9.3,8.9a34.1,34.1,0,0,0,16.7,2.4,37.1,37.1,0,0,0,20.7-9.1c1.5-1.3-.6-3.4-2.1-2.2-8,6.9-18.3,10-28.7,7.7-3.6-.7-6.8-1.8-9.4-4.5a36.9,36.9,0,0,1-6.4-8.7c-2.6-4.4-4.3-9-6.3-13.6-.7-1.6-3.1-2.1-4.6-2.8s-3-1-4-1.9.1-3.4.7-4.6c2.2-4.9,6.3-8.9,5.7-14.6-.4-3.3-1.5-6.5-2-9.8a53.2,53.2,0,0,1-.5-9.8,57.6,57.6,0,0,1,4.3-19.2c.8-1.8-2.1-2.6-2.9-.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M723,100.7l2-.4h3c-.3,0,.2.1.2.1a6.7,6.7,0,0,1,1.9.5,1.6,1.6,0,0,0,1.9-1.1,1.6,1.6,0,0,0-1.1-1.8,13.3,13.3,0,0,0-8.6-.1,1.6,1.6,0,0,0-1.1,1.9,1.4,1.4,0,0,0,1.8,1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M729.7,109.1a2,2,0,0,0-1.6-1.6,2.2,2.2,0,0,0-2.1.2c-1.5.9-1.5,2.7-1.3,4.2a10,10,0,0,0,1.4,3.6,5.7,5.7,0,0,0,1.5,1.6,2.4,2.4,0,0,0,2.6.1c1.5-.9,1.1-3,.7-4.5s-.5-1.3-.8-2-.9-1.5-1.7-1.7a1.9,1.9,0,0,0-2.4,1.5,4.1,4.1,0,0,0,.1,2.2c.4,1.5,1.4,3.6,3.2,3.4a2.3,2.3,0,0,0,1.8-2.3,11.8,11.8,0,0,0-.4-2,5,5,0,0,0-2.3-3.5,1.6,1.6,0,0,0-2.2.9,7.9,7.9,0,0,0,.3,4.8,5.3,5.3,0,0,0,1.3,2.3,2.2,2.2,0,0,0,3.1.1,3,3,0,0,0,.3-3,7.3,7.3,0,0,0-.9-2.2,9.4,9.4,0,0,0-1.4-1.9,2.1,2.1,0,0,0-1.4-.7,1.8,1.8,0,0,0-1.9.9,4.8,4.8,0,0,0-.4,2.9,5.3,5.3,0,0,0,1.2,2.5,1.6,1.6,0,0,0,2.2,0,1.5,1.5,0,0,0,0-2.1c-.2-.2.1.2-.1,0v-.3c-.1-.1-.2-.4-.1-.2h0a.3.3,0,0,1-.1-.2.4.4,0,0,0-.1-.3h0v-.5c0-.3.1,0,0,0s.1-.2.1-.3.1-.1,0,.1-.2.2-.7.4-.5.2-.7,0h0l.2.2c0,.1.1.2.2.3h-.1c.1,0,.1.1.1.2l.5.6.3.6v.2s-.1-.3-.1-.1l.2.4a2.5,2.5,0,0,0,.2.7v.4a.1.1,0,0,1,.1.1h0c-.1.1,0-.2,0-.2l.2-.3a1,1,0,0,1,.5-.4h.6c.1,0,.2.2.1,0h-.2l-.3-.7h-.1s.1.2.1.1l-.2-.5c-.1-.2-.1-.5-.2-.8s-.1-.4,0-.2h0c0-.1,0-.1-.1-.2a2.8,2.8,0,0,1,.1-.9h0V110l-2.2.9.3.2c.3.1-.3-.3,0,0s.2.3.3.3v.2c0,.1.1.1.1.2a.1.1,0,0,0,.1.1h-.1l.3,1.1a.6.6,0,0,1,.1.4c0,.1.1.2.1.3s.1.5,0,.2,0,0,0,.1.1-.4,0-.1a1.1,1.1,0,0,1,1.4-.6c.4.3,0,.1,0,0h0a1.5,1.5,0,0,1-.3-.7h0a.4.4,0,0,1-.1-.3c-.1-.2-.1-.4-.2-.6s0,.3,0-.1v-.2h0v0l-.2.4h-1.4l-.2-.2.3.6c.1.2.3.4.3.6s0,0,0,.1l.2.3.3,1.2v.4h0a.4.4,0,0,1,.1.3c0,.1-.1.5,0,.1v-.2a.5.5,0,0,1,.4-.3h.3c-.2,0-.1,0,.1.1s.3.2,0,0h-.1l-.2-.3c-.3-.2.1.2-.1,0l-.6-1.1-.2-.3h0a6.4,6.4,0,0,1-.2-.7c-.1-.2-.1-.4-.2-.6v-.3h0v-.8c0-.3-.1.3,0,0s0-.3.1-.3v0h-.4c.3.1.1.1-.1,0h.1c.1.1.1.1-.2,0s-.3-.3-.1-.1a.8.8,0,0,1-.2-.4h0a1.5,1.5,0,0,0,1.9,1.1,1.7,1.7,0,0,0,1-1.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M783.7,105.8c-2.5-1.6-4.5,1.6-5.4,3.5a13.9,13.9,0,0,0-1.2,3.6c-.2,1.2-.2,2.6,1.1,3.2s2.5-.6,2.8-1.9.1-.1.2-.2l-.3.2h0l.2.3a1.3,1.3,0,0,1,.1.6,11.6,11.6,0,0,1-.3,3.7c-.1.3-.4,2.2-1.1,2s-2.6,2.5-.7,2.9c4.3,1,5.2-5.3,5.1-8.3s-.6-3.5-2.4-4.1a2.7,2.7,0,0,0-2.6.4c-.7.6-.8,1.4-1.3,2.1l.5-.6v.2l.7-.2h.2l.6.4c.3.2.1.5.2,0s.1-.7.2-1l.6-1.8a16.2,16.2,0,0,1,1-1.8l.5-.6c.3-.4.2.1-.1-.1,1.6,1,3.1-1.6,1.5-2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M790.6,155.1c1.6,2.8,3.2,5.7,5.9,7.6s7.4,2.4,11.2,1.9a1.5,1.5,0,0,0,1.5-1.5c0-.7-.7-1.6-1.5-1.5a16.7,16.7,0,0,1-5.9,0,8.4,8.4,0,0,1-3.8-1.5l-1.4-1.2-1.1-1.4-2.3-3.9c-.9-1.7-3.5-.2-2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M761.1,161.7l-10.6,4.6-7.3.9-2.1,7.3a122.6,122.6,0,0,0,12.1-4.5C758.4,167.6,763.8,161.5,761.1,161.7Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M712.8,76.1a12.8,12.8,0,0,1,7.9-5.9c4.4-.9,7.2,2.8,9.3,6s4.3,8.1,7.4,11.5c6,6.7,14.2,12.8,23.3,14.1,6.4.9,12.2-1.1,17.2-5,1.5-1.1-.6-3.3-2.1-2.1a19.3,19.3,0,0,1-16,3.9,33,33,0,0,1-13.5-6.7,46.6,46.6,0,0,1-8.1-7.9c-3.6-4.6-5.3-10.5-9.8-14.5s-14.9-1.1-18.2,5.1c-.9,1.7,1.7,3.2,2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M757.1,101c4.6,2.3,7.8,6.7,10.3,11,.9,1.5,2.2,3.4,4.2,2.5a6.3,6.3,0,0,0,2.7-3.7c.6-1.6.5-3.3,1.1-4.8a10.8,10.8,0,0,1,6-5.7c6.6-2.7,9.3,7.5,9.3,12.1a19.1,19.1,0,0,1-9.9,16.6c-1.7.9-.2,3.5,1.5,2.6a22.2,22.2,0,0,0,10.8-14.2c1.4-5.9.5-13.3-3.9-17.8a8,8,0,0,0-7.3-2.6,13.7,13.7,0,0,0-7.4,4.8,9.4,9.4,0,0,0-2,3.5c-.3.9-.3,2-.5,2.8a8.8,8.8,0,0,1-.7,2.3l-.6,1c-.5,1-.1-.2.1.4-.4-1.3-1.9-3.1-2.7-4.3a30.5,30.5,0,0,0-3.1-4,19.8,19.8,0,0,0-6.4-5.1c-1.7-.8-3.2,1.7-1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M314.3,190.6c-4.9-6.7,3.7,21.3,13.5,24,0,0,.6-.5,1.8-4.4a29.5,29.5,0,0,1,2.6-5.7S322.4,201.8,314.3,190.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M718.4,67.9a12.5,12.5,0,0,0-12.7-3.7c-4.5,1.3-8.2,5.1-10.2,9.2-4.3,8.6-3.5,19.8.3,28.4,2.3,5.1,6.5,9.4,12.1,10.7a1.5,1.5,0,0,0,.8-2.9c-11-2.6-13.9-17.1-12.9-26.8.6-4.8,2.4-9.6,6-12.9s10.4-4.4,14.5.1c1.3,1.4,3.4-.7,2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M714.4,71.3a6.3,6.3,0,0,0-5.9-1.2,8.2,8.2,0,0,0-4.8,4c-2.5,3.9-3.2,9.1-2.9,13.7a1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5,21.8,21.8,0,0,1,1.9-11.2,6.9,6.9,0,0,1,2.9-3.4,3.8,3.8,0,0,1,3.7.2,1.5,1.5,0,0,0,2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M695.5,93c-5.5-9.6-7.1-21.7-3.6-32.3s13.8-14.3,23.9-16.8c1.8-.5,1-3.3-.8-2.9-5.4,1.3-10.9,2.9-15.6,5.8a24,24,0,0,0-10.1,12.5c-4.1,11.5-2.4,24.8,3.6,35.2a1.5,1.5,0,0,0,2.6-1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M718.5,43.1c9.6-13.2,27.9-18.5,43.5-19.2,8.7-.5,17.1,1.8,25,5.4a87.4,87.4,0,0,1,20.5,12.9C820,53,828,68.8,830.1,85.1a64.4,64.4,0,0,1,.5,12.4c-.1,2.4-.4,4.7-.5,7.1a54,54,0,0,1-3.8,16.8c-1.9,5-4.8,9.3-7.2,14.1a37.7,37.7,0,0,0-3.7,11.8c-.4,4-.4,10.7,3.5,13.2,1.6,1,3.1-1.6,1.5-2.6s-1.5-2.6-1.8-3.9a21.3,21.3,0,0,1,.2-8.7,39.1,39.1,0,0,1,5.1-12.3,62.4,62.4,0,0,0,5.9-12.2,65.4,65.4,0,0,0,3.3-16.4c.1-2.7.5-5.4.6-8.2a77.4,77.4,0,0,0-.8-12.7c-2.4-16.3-10.4-32.2-22.9-43A87,87,0,0,0,789.1,27c-7.5-3.4-15.4-6-23.6-6.2a77.1,77.1,0,0,0-28.8,5.4c-8.2,3.3-15.6,8.2-20.8,15.4-1.1,1.5,1.5,3,2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M801.6,152.9a22.1,22.1,0,0,0,6.3,7.9,10,10,0,0,0,9.3,1.6,1.5,1.5,0,0,0,1.1-1.8,1.7,1.7,0,0,0-1.9-1.1,7.1,7.1,0,0,1-7.1-1.4c-2.3-1.7-3.8-4.3-5.1-6.7s-3.5-.2-2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M719.2,68c1.9-3.4,6.4-4,9.8-3s7.9,5.3,10.9,8.8c1.3,1.4,3.4-.7,2.1-2.1-3.5-4.1-7.6-8.6-13.1-9.8s-9.8.3-12.3,4.6c-1,1.6,1.6,3.2,2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M784.7,126.8a101.9,101.9,0,0,0,3.3,20.5c1.5,6,3.6,12.2,7.4,17.3a21.1,21.1,0,0,0,6.4,5.9c2.5,1.5,5.2,1.9,8.1,2.3a40.7,40.7,0,0,1,18.1,7.5c5.5,4,10.2,9,14.7,14.1A107.4,107.4,0,0,1,856,213.1c4,6.7,8,13.6,10.7,20.9q8.5,22.6,15.8,45.8c3.1,9.7,6,19.6,8.5,29.5a152.9,152.9,0,0,1,4.5,25.2c.8,9.9,2.3,20.3.5,30.1s-7.2,16.6-14.4,22.5a72.5,72.5,0,0,1-25.2,13.2,204.6,204.6,0,0,1-30.1,6.7c-18.4,3-36.9,4.3-55.4,5.9-2.5.2-5,.4-7.5.8l-3.6.7a10.6,10.6,0,0,1-2.5.2c-.5,0-.7,0-.8-.2a8.5,8.5,0,0,1-.3-.9c-.2-.7-.3-1.5-.5-2.3a33.2,33.2,0,0,0-2.3-6.7c-1.4-3-3-5.9-4.3-9s-2.7-6.2-4-9.3-3.6-9.5-7.1-12.7a6.2,6.2,0,0,0-1.9-1.2l-.6-.2c.5-.1.5,1.8.5,1.9h0l.6-.4,1.7-.9c9.3-4.6,19.2-8.1,28.8-12,12.8-5.4,25.3-12,38.6-16.2a72.2,72.2,0,0,1,16-3.3c4.9-.3,9.2.8,14,1.9l13.4,3.1c1.9.4,2.7-2.5.8-2.9l-14.7-3.4c-4.7-1.1-9-2-13.9-1.6-13.1.9-25.9,6.3-37.7,11.8s-23.6,10.2-35.5,15.1a124.2,124.2,0,0,0-11.8,5.2c-1.3.7-4.9,2.8-2.2,4.4a6.9,6.9,0,0,0,1.3.5c.7.3,1.2,1.1,1.7,1.7a44.8,44.8,0,0,1,3.7,6.8c2.7,6,5,12.2,8,18.2a41.7,41.7,0,0,1,3.6,8.4c.4,1.5.6,3.1,1.1,4.6,1.2,3.4,4.9,2.7,7.7,2.1,5.3-1,10.9-1.3,16.5-1.8,9.3-.7,18.6-1.5,27.9-2.5,10.9-1.2,21.7-2.7,32.5-4.8a144.8,144.8,0,0,0,28.7-8.3c9.2-3.9,18.2-10.1,24.5-17.9s8.1-15.6,8.4-24.7c.1-5.3-.3-10.5-.7-15.7s-.6-9.7-1.3-14.4a214.4,214.4,0,0,0-6.2-27.5c-5.2-19.1-11.6-37.8-18.3-56.4-1.5-4.2-3-8.5-4.6-12.7a140.5,140.5,0,0,0-7.2-13.9A138,138,0,0,0,848.8,197c-8.2-10.5-18.7-21.5-31.7-25.6a76.7,76.7,0,0,0-9.3-1.9,14.2,14.2,0,0,1-7.9-4.2c-4.7-4.8-7-11.4-8.7-17.7a92.4,92.4,0,0,1-3.5-20.8c-.1-1.9-3.1-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M730.4,175.5c2.2,6.8,8.5,11.7,14.8,14.3a60.1,60.1,0,0,0,20.1,3.7c12.8.5,26.2-1.4,37.4-7.8a42.1,42.1,0,0,0,8.8-6.4c1.9-1.9,3.6-4.4,3-7.3s-3.2-1-2.8.8-2,4.1-3.3,5.2a40.7,40.7,0,0,1-7.2,5.1,53.7,53.7,0,0,1-14.1,5.5c-12,2.7-25.8,3.1-37.7-.5-6.6-2.1-13.9-6.4-16.1-13.4-.5-1.8-3.4-1-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M719.3,152.4a21.4,21.4,0,0,0,15.1-4.2,1.5,1.5,0,1,0-1.5-2.6,18.9,18.9,0,0,1-13.6,3.8,1.5,1.5,0,0,0-1.5,1.5,1.6,1.6,0,0,0,1.5,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M735.1,136.6l2.2.8h.4l.5.3,1.1.6,1,.6.5.3.2.2h.3l.2.2.5.4.9.9a1.5,1.5,0,0,0,2.2-2.1,21.6,21.6,0,0,0-9.2-5.4,1.6,1.6,0,0,0-1.9,1.1,1.5,1.5,0,0,0,1.1,1.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M375.8,109.8a73,73,0,0,1,1.6,22.8c-.3,2.9-1.1,5.7-1.2,8.5a36.8,36.8,0,0,0,.5,5.8,26.3,26.3,0,0,0,1.9,7.7c1.1,2.6,3,4.8,4.5,7.2,2.8,4.4-3,8.3-5.8,11.1-1.3,1.4-2.8,2.8-3.5,4.6s-.7,2.7-1.1,4a90.2,90.2,0,0,1-4.8,13.5c-2,4.3-4.3,7.7-8.9,9.3s-12,1.9-17.8.6-13.8-5.2-19.8-9.5a63.2,63.2,0,0,1-8.5-7c-1.3-1.3-3.4.8-2.1,2.1,6.8,6.9,15.8,13,25,16a40.7,40.7,0,0,0,19,1.9c4.8-.7,9.6-2.5,12.6-6.5s4.9-9.2,6.5-14.1l2-6.5a10.6,10.6,0,0,1,1.3-3.9c2.8-3.8,7.9-6.3,9.4-11a6.8,6.8,0,0,0-1-6.3c-1.7-2.6-3.7-4.9-4.7-7.9a34,34,0,0,1-1.6-8.9,42.5,42.5,0,0,1,.6-7.1,75.4,75.4,0,0,0-1.2-27.2,1.5,1.5,0,0,0-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M312.1,171.6c-5.3-.8-9.7-6.7-12.1-11.1s-2.6-14.7,2.8-19.2c3.3-2.7,7.7-1.8,11.1.3a14.1,14.1,0,0,1,5.3,6.5c.9,2,4.4,10.8,7.5,6.4,1.3-1.8,1.2-4.8,1.5-6.9s.6-6.8,2.1-9.8-1.8-3.3-2.6-1.5a27.8,27.8,0,0,0-2.3,9c-.2,1.4-.3,2.9-.5,4.4a7.8,7.8,0,0,1-.2,1.6c0,.2-.4,1.1-.3,1.3s.4.4.5-.1l-.8-1.1c-.7-1.2-1.3-2.5-1.9-3.7s-2.4-5.2-4.7-7.1c-5.6-4.7-13.7-5.7-18.6.5a19.6,19.6,0,0,0-1.9,20.2,32.4,32.4,0,0,0,6.1,8.2c2.2,2.2,5,4.5,8.3,5s2.6-2.6.7-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M308.3,148.2c1.1-.4,2.1,1.4,2.5,2.2a9,9,0,0,1,.6,4.3l2.7-.7c-.9-1.6-2.5-3.1-4.4-2.5s-2.4,2.9-2.4,4.6a9.2,9.2,0,0,0,1.3,5.4,3.9,3.9,0,0,0,5.1,1.5c1.7-.9.2-3.4-1.5-2.6s-1.1-.6-1.3-1a6.4,6.4,0,0,1-.6-2.8c-.1-.2-.1-2.2.4-2.2s.7.9.9,1.1a1.5,1.5,0,0,0,2.7-.8,10.6,10.6,0,0,0-1.3-6.5c-1.1-1.9-3.2-3.6-5.5-2.9s-1.1,3.5.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M365.3,142.2a.8.8,0,0,1-1,.1l-.3-.3c-.2-.1,0,.3,0,0v.3c0,.4.1.9.1,1.4v1.9c0,.2-.1.3-.1.4v.5a.4.4,0,0,0-.1.3,4.3,4.3,0,0,1-.1.5l-.2.4c0,.1-.1.3,0,.1l-.3.6c-.1.1-.2.2,0,.1h0c-.1.2-.2,0,0,0h.4s.3.1.2.2v-.2c0-.1-.1-.3,0-.1s-.1-.2-.2-.4-.1-.4-.1-.6h0V146c0,.3.1-.2.1-.2l.3-1.4.2-.5c.1-.4-.1.1,0-.1v-.2h0l-.5-.2s-.2-.2-.1-.2v.3a.6.6,0,0,1,.1.4c.1.2,0-.1,0,.1s.1.4.1.7-.1.6-.1.3a1.5,1.5,0,0,1-.1.7c0,.1-.1.2-.1.3s-.2.5-.1.2-.1.2-.1.3v.2c-.1.1-.1,0,0-.1h.6c-.4-.1.7.3.6.6s-.1-.4-.1-.5v-.3c0,.3,0-.2-.1-.2a8.1,8.1,0,0,1,.1-1.6v-.2c0-.2.1-.3.1-.5a.4.4,0,0,0,.1-.3v-.2a.9.9,0,0,1-.7.6h-.7a.9.9,0,0,1-.7-.6v.2a.9.9,0,0,1,.1.5.4.4,0,0,1,.1.3h0v1.1c0-.3,0,.2-.1.3a1.1,1.1,0,0,1-.1.5v.3h0l2.3-.3h0c.1.1.1.1,0-.1h0c-.1-.1,0,.3,0,0v-.4c0-.3-.1.1,0,0s0-.3.1-.4a1.9,1.9,0,0,1,.2-.7,1.6,1.6,0,0,0-1.1-1.9,1.5,1.5,0,0,0-1.8,1.1c-.5,1.5-.7,3.2.5,4.5a1.5,1.5,0,0,0,2.4-.3,7,7,0,0,0,.3-5.5,2.4,2.4,0,0,0-.9-1.3,1.8,1.8,0,0,0-2.2.3,4.5,4.5,0,0,0-1,2.8,8.7,8.7,0,0,0,.1,2.8c.2,1.1.6,2.1,1.7,2.3a2.5,2.5,0,0,0,2.7-1.4,6.2,6.2,0,0,0,.9-2.6c.2-1.9-.1-4.8-2.5-4.9s-3,2.2-3.4,3.9a8,8,0,0,0,.4,5.5,2.6,2.6,0,0,0,2.9,1.4,3.7,3.7,0,0,0,2-1.9,12.5,12.5,0,0,0,1-5.7c-.1-1,0-2.3-.5-3.1a2.1,2.1,0,0,0-3.4-.6,1.4,1.4,0,0,0,0,2.1,1.7,1.7,0,0,0,2.1,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M372.2,124.2a11.5,11.5,0,0,0-13.8,1.6c-1.4,1.3.7,3.4,2.1,2.1a8.4,8.4,0,0,1,10.2-1.1,1.5,1.5,0,0,0,1.5-2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M377.8,92.5c.9,7.4-.7,14.3-6.1,19.6s-12.1,7.3-19.1,7.4a1.5,1.5,0,0,0,0,3c7.8-.2,15.6-2.7,21.2-8.3s7.9-13.6,7-21.7c-.2-1.9-3.2-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M380.4,129c6.8-3.9,9.9-11.6,10.4-19.2a54.6,54.6,0,0,0-4.2-24.9,46.7,46.7,0,0,0-5.7-9.6,38.8,38.8,0,0,0-3.9-4.2l-2-1.7c-.9-.6-.1.1-.3-.1s-2.7-3.3-4.1-4.9a75.8,75.8,0,0,0-24.7-17.7c-8.2-3.5-16.9-4.5-25.6-4.8-10.6-.3-21.5,1.2-31.2,5.7a40.3,40.3,0,0,0-8.3,4.9l-2,1.5-1.4,1.4H277a78.1,78.1,0,0,0-8.1,2.9,56.1,56.1,0,0,0-26.5,24.4c-7.6,13.9-11.1,29.7-8.3,45.4s11.1,30.2,21.2,42.1c3,3.4,6.2,6.5,9.4,9.8a19.5,19.5,0,0,1,5.1,13.2,11.9,11.9,0,0,1-2.7,8.1c-1.3,1.4.8,3.5,2.1,2.1,4.2-4.5,4.3-11.3,2.5-17a21.5,21.5,0,0,0-5.9-9.5c-3.1-3.2-6.3-6.4-9.2-9.9a100.5,100.5,0,0,1-12-18.2c-7.8-14.9-10.8-31.5-6.4-47.9,3.6-13.6,11.1-26.6,22.8-34.7a53.2,53.2,0,0,1,12-6.4c1.7-.6,3.6-.9,5.3-1.6s2.2-1.8,3.2-2.6a39.3,39.3,0,0,1,4.2-2.9,43.5,43.5,0,0,1,8.4-4.1,66.5,66.5,0,0,1,16.5-3.5,98.6,98.6,0,0,1,20.3.4c11.6,1.5,22.4,7.3,31.2,14.8a99.4,99.4,0,0,1,8,7.9l1.8,2.3.2.2a28.5,28.5,0,0,0,2.6,2.3c5.9,5.3,9.6,12.5,11.6,20.1s2.9,17.7-.5,25.4a17.1,17.1,0,0,1-7,7.8c-1.6.9-.1,3.5,1.6,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M273.8,200.6a70.8,70.8,0,0,0,15.6-8.3c7.3-5.4,14.9-12.4,18.2-21,.7-1.8-2.2-2.6-2.9-.8a33.6,33.6,0,0,1-7.1,10.5,66.6,66.6,0,0,1-10.5,9.3,54.1,54.1,0,0,1-7.4,4.2l-4.1,2-1.8.9-.6.2H273c-1.8.7-1,3.6.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M370,190.5a11.1,11.1,0,0,1-11.4-1.7c-2.1-1.8-5-4.7-3.4-6.9s4.3-1.7,6.4-1.6c4.7.5,7.1.7,10.7.9,1.1.1,1.7.4.8,3S371.9,189.6,370,190.5Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M369.2,189.2a9.6,9.6,0,0,1-9.1-1.1,15.4,15.4,0,0,1-2.9-2.8c-.6-.7-1.4-1.9-.6-2.7s2.3-.8,3.3-.8,3.3.2,5,.3l4.4.4,2,.2h1.3l-.3-.2s-.3-.4-.2-.4-.1.5-.1.6l-.9,2.6c-.3,1.3-.6,3.1-1.9,3.8s-.2,3.4,1.5,2.6,2.5-2.8,3-4.5l.9-3a5,5,0,0,0,.4-2.7c-.3-1.6-1.8-1.8-3.2-1.9l-5.4-.4c-2.1-.2-4.2-.5-6.2-.5a7.9,7.9,0,0,0-5.4,1.4c-3.6,3,0,7.2,2.5,9.4a12.7,12.7,0,0,0,13.4,2.2c.8-.3.9-1.4.6-2.1A1.7,1.7,0,0,0,369.2,189.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M323.2,138c15-6.4,29.6-16.2,36.8-31.3.8-1.7-1.8-3.3-2.6-1.5-7,14.7-21.2,24-35.7,30.2-1.7.8-.2,3.4,1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M419,386.1c6.8-11.9,16.3-22.2,24.9-32.7,10.2-12.2,20.6-24.5,35.2-31.9a40.5,40.5,0,0,1,11.8-3.7,92.8,92.8,0,0,1,21.7-1.2c10.8.7,21.8,3.8,30.2,10.8.7.6,1.2.7.3,1.3a9.6,9.6,0,0,1-4.5.9c-4.5.1-8.4-2.3-12.8-3.2a39.7,39.7,0,0,0-11.4-.4c-3.2.3-6.3.9-9.5.9a1.5,1.5,0,1,0,0,2.9c6.9.1,13.5-1.9,20.4-.4,4.2.9,7.9,3,12.2,3.2,2.7.1,6.2-.2,8.2-2.2,5.8-5.9-16.9-13.9-19.8-14.7a75.2,75.2,0,0,0-25.9-2,88.4,88.4,0,0,0-15.3,2.3c-6.9,1.9-13.3,6.2-18.9,10.5A113.9,113.9,0,0,0,447.9,344c-5.7,6.7-11.3,13.5-16.9,20.3s-10.5,13-14.5,20.3c-1,1.6,1.6,3.1,2.5,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M496.2,340.4a66.1,66.1,0,0,0,13.3-1.5c4.3-.8,9.2-2.3,11.9-6s.8-5.1-1.6-6.7-3.1,1.5-1.5,2.5,1.4,1.2.9,2.1a7.2,7.2,0,0,1-2.5,2.4,21.3,21.3,0,0,1-6.3,2.5c-2.6.5-5.1.9-7.7,1.2s-4.3.5-6.5.5-1.9,2.9,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M502.3,348.2c1.8-.5,4.3,1,5,2.6s-1.1,4.7-3.1,5.6c-4.2,1.9-9.1,2.3-13.5,3.7a43.9,43.9,0,0,0-13.8,7.4c-1.2,1-3,2.2-3.8,3.7s1.7,3.2,2.6,1.5a.3.3,0,0,0,.1-.2c.2-.2-.1.2,0,.1l.3-.4a20.4,20.4,0,0,1,2.7-2.3,41.6,41.6,0,0,1,12.7-7c4.1-1.2,8.4-1.8,12.4-3.2s7.1-4,6.7-8.1-5.2-7.3-9.1-6.2a1.5,1.5,0,1,0,.8,2.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M506.9,357.2c2.5,2.8-4,6.9-5.7,8.2s-6.2,4.8-9.4,7.2-9.5,6.5-13.1,10.8c-1.2,1.5.9,3.6,2.1,2.1A35.9,35.9,0,0,1,487,380c3.1-2.5,6.3-4.8,9.5-7.2s7.2-5.3,10.5-8.3,4.7-6.4,2-9.5c-1.3-1.4-3.4.7-2.1,2.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M507.3,364.4c4.4,1.3-1.8,8.1-3,9.6l-8.4,10.7c-3,3.8-6.2,7.5-9.2,11.3-4.5,5.6-8.5,12.2-14.5,16.3a56.9,56.9,0,0,1-15.9,7.1c-2.7.9-5.5,1.6-8.1,2.7l-10.6,4.4-38.1,16c-21.8,9-43.8,17.6-66,25.5-11.1,3.9-22.2,7.7-33.5,10.8s-21.7,5.4-32.7,2.2-18.7-10.4-26.4-17.5-14-17-19.3-26.4a19.8,19.8,0,0,0-1.1-2c-.9-1.7-3.5-.2-2.6,1.5a149.2,149.2,0,0,0,15.3,23.1,101.9,101.9,0,0,0,12.2,11.5,69.3,69.3,0,0,0,13.4,9.5,41.1,41.1,0,0,0,17.8,4.8,62.6,62.6,0,0,0,17.3-2,337.8,337.8,0,0,0,32.5-9.9c23-7.9,45.7-16.7,68.2-25.9l40.8-17,12.9-5.5a73.9,73.9,0,0,1,7.1-2.4,70.7,70.7,0,0,0,16.2-6.6,32.2,32.2,0,0,0,7.4-5.8c2.9-3,5.2-6.5,7.8-9.7s6.4-7.9,9.7-11.9,5.5-7.1,8.3-10.7l4-5.1a12.4,12.4,0,0,0,2.8-5,5.4,5.4,0,0,0-3.5-6.5,1.5,1.5,0,0,0-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M509.9,365.7c8.9-1.4,17.8-2.6,26.8-3.6,1.9-.3,1.9-3.3,0-3-9.2,1-18.4,2.3-27.6,3.7-1.9.3-1.1,3.2.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M568.1,361.8c-1.7,1.7-4.4,2.6-6.5,3.4s-6.1,1.9-9.1,3.1a52.8,52.8,0,0,0-12,7.3c-2.9,2.2-5.4,5.2-9.1,6.1a9.4,9.4,0,0,1-4.4,0c-2-.6-2.2-2.3-1.8-4.2a19.5,19.5,0,0,1,4.7-7.8c2.4-2.6,5.2-5,7.7-7.5s5.8-5.9,8.5-9c1.2-1.5-.9-3.6-2.2-2.2a110,110,0,0,1-8.7,9.4c-2.5,2.4-5.2,4.8-7.6,7.4s-9.2,12.5-3,16.2c2.7,1.5,6.4,1.1,9.2.1a17.4,17.4,0,0,0,5.9-4.1,55,55,0,0,1,11.3-7.7c3.4-1.8,7.2-2.6,10.8-4s6.2-2.2,8.4-4.4-.8-3.4-2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M546.8,329.4c4.1-1.5,8.5-.6,12.6-.3a1.5,1.5,0,0,0,1.5-1.5,1.4,1.4,0,0,0-1.5-1.5c-4.4-.3-9.1-1.2-13.4.4a1.6,1.6,0,0,0-1,1.8,1.5,1.5,0,0,0,1.8,1.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M735.4,373.1,720.5,378c-4.3,1.4-9.1,2.4-12.9,4.8s-6,5.4-8.6,8.2-5.3,6-7.8,9.2c-3.8,4.9-11.2,14.2-5.9,20.4,2.6,3.1,5.9,1.6,8.4-.8a95.9,95.9,0,0,0,8-8.9c5.7-7,11.1-14.6,18.3-20.2,1.6-1.1.1-3.7-1.5-2.6-5.5,4.3-9.9,9.6-14.3,15l-6.9,8.4c-2.1,2.5-4.4,5.6-7.1,7.4s-3.4-.8-3.6-2.7a11.7,11.7,0,0,1,1.7-6.3,46.5,46.5,0,0,1,5.6-8.3c2.2-2.8,4.6-5.6,7-8.2a56.8,56.8,0,0,1,7.3-7.4c3.8-2.8,9-3.8,13.5-5.3l14.5-4.7c1.8-.6,1-3.5-.8-2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M689.3,421.5a6.8,6.8,0,0,0,7.7,6c4.4-.4,7.4-3.7,10.1-6.9,5-5.9,10.4-11.5,15.3-17.4,1.3-1.4-.8-3.6-2.1-2.1-4.1,5-8.6,9.7-12.9,14.6-2.1,2.4-4,5.2-6.6,7.2a7.1,7.1,0,0,1-5.4,1.6,3.5,3.5,0,0,1-3.1-3c-.2-1.9-3.2-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M695.7,427.2c-.8,3.8,2.5,6.5,6.1,6.2s6.8-2.9,9.5-5.2c5.9-4.8,11.3-10.1,16.9-15.2,1.4-1.3-.7-3.4-2.1-2.1-4.5,4.1-8.8,8.2-13.3,12.2a55.6,55.6,0,0,1-6.6,5.4,11.6,11.6,0,0,1-4.3,1.8c-1.5.3-3.7-.4-3.3-2.3s-2.5-2.7-2.9-.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M707.9,427.6c-1.6,1.9-3.2,4.3-3.1,6.9a5.3,5.3,0,0,0,5,5c5.4.3,10.5-5.1,14.2-8.4l6.7-6.4c2.3-2.1,4.5-4.3,7.8-4.8,5.7-.7,11.5-2.3,16.3-5.7,1.5-1.1.1-3.7-1.5-2.6a32.7,32.7,0,0,1-14.2,5.3,13.7,13.7,0,0,0-6.8,2.5c-1.8,1.4-3.4,2.8-5,4.3a107.5,107.5,0,0,1-11.2,10.1c-1.7,1.2-4.1,3-6.3,2.7-3.8-.5-1.1-5.2.2-6.8s-.9-3.5-2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M704,433.3v8.1c0,7.1,0,14.2-.1,21.3V494c-.1,12.7-.1,25.3-.2,38s0,27.9-.1,41.8,0,28-.1,42-.1,26.1-.1,39.1c0,11.1-.1,22.2-.1,33.2,0,8.1,0,16.1-.1,24.1,0,3.9-.1,7.7,0,11.6v.6a1.5,1.5,0,1,0,3,0v-8.1c0-7.1.1-14.2.1-21.3,0-10.4,0-20.8.1-31.3,0-12.6,0-25.3.1-38s.1-27.8.1-41.8.1-27.9.1-41.9.1-26.2.1-39.2c.1-11.1.1-22.2.1-33.2,0-8,.1-16,.1-24,0-3.9.1-7.8,0-11.7v-.6a1.5,1.5,0,0,0-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M705.7,464.3H820.6a1.5,1.5,0,0,0,0-3H705.7a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M112.1,617.8c-15.2-12.1-35.6-20.1-55.2-17.3-10.8,1.4-15.2,11.8-16.3,21.5-.8,6.5-1.1,13.1-1.8,19.6s-1.7,13.6-2.8,20.3c-2.2,12.7-6.3,25.8-4.7,38.7a42.1,42.1,0,0,0,13.2,24.7A56.6,56.6,0,0,0,70,738.7a45.7,45.7,0,0,0,15.2,1.4,24.1,24.1,0,0,0,7-1.8,35.4,35.4,0,0,0,4.1-2.6c4.7-3.1,8.2-6.9,9.2-12.7s-.3-10.4-1-15.5c-.4-2.6-.7-5.2-1.1-7.8a2.2,2.2,0,0,1-.1-.8c-.4-1.9-3.3-1.1-2.9.8.8,4.7,1.3,9.5,2,14.3s.9,8.6-1.2,12.6a14.7,14.7,0,0,1-4.9,5.6,37.7,37.7,0,0,1-5.4,3.4c-4.4,2-9.5,1.9-14.2,1.3A55.9,55.9,0,0,1,51.2,727c-7.2-5.2-13.1-12.5-15.7-21.1-3.5-11.5-.3-23.5,1.9-34.9s3.9-24.1,5.1-36.3c.9-9.9,0-24.7,10.4-30.1,3.3-1.7,7.6-1.6,11.2-1.6a63.1,63.1,0,0,1,12.2,1.2,76.8,76.8,0,0,1,27.6,11.3,62.5,62.5,0,0,1,6.1,4.4c1.5,1.2,3.6-.9,2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M60.3,695.8c5.2-1.7,10.2-2.8,15.8-2.3s12.2,2.6,18,4.5c1.9.7,2.6-2.2.8-2.8-6.1-2.1-12.3-4.2-18.8-4.7a40.6,40.6,0,0,0-16.6,2.4c-1.8.6-1,3.5.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M357.7,710.5c-1.3,8.5,6.1,13.8,12.6,17.4s13,5.4,19.5,7.9a74.9,74.9,0,0,1,8.1,3.8l.6.3a13.2,13.2,0,0,1,2,1.2,26.5,26.5,0,0,1,10.3,15.8c1.3,6.3-.2,14.5-6.3,17.9a34.5,34.5,0,0,1-17.3,3.8c-7.9-.2-15.6-2.2-23.1-4.4s-16.8-5.4-25.1-8-18.5-5.4-27.5-8.8a59.6,59.6,0,0,1-9.3-4.1c-1.4-.9-3.5-2-3.9-3.7a1.5,1.5,0,0,0-2.9.8c1,4.1,6.8,6.4,10.2,7.9,7.6,3.3,15.7,5.7,23.7,8.1s17.6,5.6,26.4,8.4,16.5,5.1,25,6.3a46.6,46.6,0,0,0,19.3-1.3,24,24,0,0,0,8.5-4.1,16.9,16.9,0,0,0,4.9-8.6c1.9-7.3.2-14.6-4-20.8-2.5-3.7-5.9-7.4-10-9.3-2.4-1.2-4.8-2.4-7.3-3.4s-8-3.1-12.1-4.6a67.9,67.9,0,0,1-11.2-5.4c-4.2-2.7-9.1-6.7-8.2-12.3.2-1.9-2.7-2.7-2.9-.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M303.2,745.5c6.1,2.8,12.4,5.1,18.4,7.9l6.5,3.1c5.3,2.2,10.7,4.2,16.2,5.9,14.8,4.9,30.8,9.3,46.5,9,6.6-.1,14.1-1.3,18.9-6.2a1.5,1.5,0,0,0-2.1-2.1c-4,4-10.1,5-15.6,5.3a94.2,94.2,0,0,1-22.4-2.3,210.6,210.6,0,0,1-39.2-11.9l-5.8-2.7c-6.5-3.1-13.3-5.5-19.9-8.6-1.7-.8-3.2,1.8-1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M63.8,607.1c-3.6,3.4-7.1,7.2-9,11.8s-2.2,8.8-2.8,13.2c-1.3,10.4-2.1,20.8-5,30.9s-6,19-6.2,28.9,3.6,17.8,9.1,24.9,15.3,14.4,25.7,15.8c1.8.2,2.7-2.7.8-2.9a36.1,36.1,0,0,1-22.6-12.8c-5.7-6.6-10-15.2-10-23.9s3-18.4,5.6-27.3,3.9-18.9,5-28.6a89.3,89.3,0,0,1,2.3-14.5c1.4-5.5,5.2-9.6,9.2-13.4,1.4-1.3-.7-3.4-2.1-2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M401.7,378.4a48.8,48.8,0,0,1,2.3,9.7,1.6,1.6,0,0,0,1.5,1.5c.7-.1,1.6-.7,1.5-1.5a53.3,53.3,0,0,0-2.4-10.5,1.5,1.5,0,0,0-1.8-1,1.5,1.5,0,0,0-1.1,1.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M424,673.8c1.7-3,2.3-7,3.2-10.4s2.7-9.9,4.1-14.9l12.6-46q6.6-24,13.4-47.8c1.6-5.7,3.2-11.4,4.9-17.1.9-2.9,1.7-5.9,2.8-8.7.1-.4-.2.4,0,0a2.5,2.5,0,0,1,.2-.7l1.1-2.6a60.3,60.3,0,0,1,5.9-10.2c2.5-3.4,5.9-6.8,10.1-7.9s5.7-.3,8.5-.3h4.5c.4,0,1,.2.4,0,1.8.7,2.6-2.2.8-2.9s-3.8-.1-5.3-.1c-5.2,0-10.1-.3-14.6,2.6-6.6,4.5-10.8,12.2-13.8,19.4-.1.4-.3.8-.4,1.1s-.2.5,0,.1a6.1,6.1,0,0,0-.5,1.2c-.5,1.2-.8,2.5-1.2,3.8-1.5,4.8-2.9,9.7-4.3,14.5-4.4,15.4-8.7,30.8-13,46.2s-8.9,32.4-13.4,48.6c-2.3,8.7-4.9,17.4-7,26.1a15.2,15.2,0,0,1-1.6,4.5c-.9,1.7,1.7,3.2,2.6,1.5Z"
    }
  },
  {
    "type": "polygon",
    "attrs": {
      "points": "207 446.8 223.6 442.4 218 435.7 207 446.8"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M240.9,552.4s12.3,24,18,29.6,15,7.3,15,7.3-18.9.1-21.1-6.3S240.9,552.4,240.9,552.4Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M320.9,710.8a48.9,48.9,0,0,1-27.2,2.3l-5.9-15.8s5.7,6,13,8.4A151.7,151.7,0,0,0,320.9,710.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M89.9,645.8s-6,31.5-5,38.1-13.7,8-13.7,8l24.1,3.8a33.1,33.1,0,0,0-2.6-6.2c-1.4-1.9-4.3-16.1-3.5-22.2S89.9,645.8,89.9,645.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M352.1,323.2s-15.1,58.2-12.7,64.5,11-8.5,11-8.5S339.7,402.1,339,407l-6.7,2.2S339.2,343.6,352.1,323.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M520.4,689.6s-1.7,15.2-5.2,27.2S474.7,743,462.5,747s-52.1,14.1-61.4-6.7,1.6-24.5,8.8-29.1,20.7-10,29.4-14,18.3-9.8,21.2-15.3c0,0,.6-5.1,10.7-2.7,0,0,15,2.9,25.1,11.7S520.3,689.4,520.4,689.6Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M519,689.6c-.5,4.2-1.2,8.5-2,12.7s-1.4,7.1-2.3,10.6a17.4,17.4,0,0,1-2.5,6.3c-2.7,3.7-6.7,6.3-10.5,8.7a138.7,138.7,0,0,1-15.3,8c-16.4,7.6-33.9,14-52.2,15.3-9,.7-20.4.6-27.6-5.9-4.3-3.8-6.4-10-7.3-15.5s0-8.6,3.2-11.7,6.3-4.5,9.6-6.4a179.3,179.3,0,0,1,20.2-9.8c7.2-3.1,14.5-6.2,20.9-10.7a29.2,29.2,0,0,0,7.3-6.7,7.9,7.9,0,0,0,1.4-2.3c.2-.5,0-.2.3-.6,1.8-2.6,6.7-1.4,9.4-.8a64,64,0,0,1,14.1,5,41.6,41.6,0,0,1,8.9,5.6,17.5,17.5,0,0,0,8.1,4.2c5.3,1,10.6-.6,15.2-2.9l2.2-1.2.7-.4c.3-.3.6-.1-.4,0,2-.1,2-3.1,0-3s-2.3,1.1-3.3,1.6a29.1,29.1,0,0,1-6.9,2.7,15.3,15.3,0,0,1-9-.3c-3.5-1.3-6.1-4.3-9.2-6.2a61.8,61.8,0,0,0-16.9-7.3c-3.7-1-8-2.3-11.8-1.2a6.3,6.3,0,0,0-3.7,2.7,22.3,22.3,0,0,1-2,3.3c-5.2,6.2-13.3,10-20.5,13.2s-14.7,6.2-21.8,9.9a89.1,89.1,0,0,0-12.6,7.5,15.5,15.5,0,0,0-6.5,10c-.9,6.1,1.4,13.1,4.3,18.4,4.8,8.8,15.4,11.5,24.8,12,19,.9,37.8-5.3,55.1-12.6,10.4-4.3,21.4-9.2,30.1-16.6a25.1,25.1,0,0,0,4.5-4.7c1.4-1.9,1.9-4.2,2.5-6.5a184.3,184.3,0,0,0,4-20.7c.1-1.3.3-2.5.4-3.7S519.2,687.7,519,689.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M410.5,744.6c6.3,3.1,14.6,2.3,21.3,1.7,8.4-.8,17.1-2.3,25-5.3,12.1-4.8,24.3-9.3,36-15.2,4.4-2.2,8.8-4.5,13.1-6.9a36,36,0,0,0,6.8-5c1.3-1.3-.8-3.4-2.2-2.1-4.4,4.4-10.6,7-16.1,9.8-7.2,3.8-14.7,7-22.2,10.1-5.1,2.1-10.3,4.1-15.4,6a93.5,93.5,0,0,1-20.2,5.1,97.2,97.2,0,0,1-14.3.9c-3.4-.1-7.2-.2-10.3-1.7s-3.2,1.7-1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M598.7,721.5a118.9,118.9,0,0,1-4.5,27.9c-3.6,12.4-41.9,27-54.5,31.2s-53.9,14.6-63.5-6.9,1.7-25.4,9.1-30.1,22.1-11.1,31.2-15.2,14.1-8.5,17.1-14.2c0,0,1.8-6.2,16.3-1.5s14.8,15.1,22.5,15.4S597.6,717.8,598.7,721.5Z",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M597.2,721.5a95.4,95.4,0,0,1-1.3,13,117.4,117.4,0,0,1-2.8,13.1,12.2,12.2,0,0,1-2.7,5.3c-3.3,3.8-7.7,6.6-11.9,9.1a168,168,0,0,1-16.4,8.3c-17.5,7.8-36.3,14.4-55.7,14.9-9.3.3-21.2-.8-27.1-9.1a30.2,30.2,0,0,1-4.1-9.4,21.6,21.6,0,0,1-1.1-9.1c.6-4.2,3.3-7.2,6.7-9.4,10.9-7.3,23.1-12.6,35.1-17.9,6.5-2.8,12.8-6.4,17.1-12.3a23.9,23.9,0,0,0,2.1-3.4c.1-.2-.3.3.1-.2a1.7,1.7,0,0,1,.6-.7,6,6,0,0,1,1.6-.8,14.7,14.7,0,0,1,7.5,0,32.9,32.9,0,0,1,10.9,4.2,30.5,30.5,0,0,1,6.4,5.5,39.4,39.4,0,0,0,4.4,4.7c3.7,3.1,8,2.5,12.3,1.2s10.1-4,15.3-5.7a21,21,0,0,1,2.4-.6c.9-.1.8.3.6-.3.6,1.8,3.5,1,2.9-.8-1.4-4-7.9-.8-10.3.2-5.2,1.9-10.7,4.9-16.2,5.3s-7.2-3.9-10-6.9a33.4,33.4,0,0,0-18.7-9.8c-3.8-.7-8.9-1-11.7,2.2a16.5,16.5,0,0,0-1.5,2.5,25.1,25.1,0,0,1-7,7.5c-6.5,4.8-14.6,7.5-22,10.9a218.8,218.8,0,0,0-19.8,10.3c-3.5,2.1-7.1,4.3-9.5,7.8s-2.7,10.6-1.3,15.8,4.2,11.7,9.3,15.4a31.2,31.2,0,0,0,14.4,5.4c11.1,1.6,22.7-.1,33.6-2.6a187.5,187.5,0,0,0,25.3-8.4c11.5-4.7,23.3-9.7,33.1-17.4,3.5-2.7,6.8-5.9,8-10.2a118.8,118.8,0,0,0,4.1-23.7l.3-3.9A1.5,1.5,0,0,0,597.2,721.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M486,778a23.8,23.8,0,0,0,9.2,2.1,82.2,82.2,0,0,0,13.1-.3,94.5,94.5,0,0,0,25.7-5.6c12.4-4.8,25.1-9.5,37-15.5,4.6-2.3,9.1-4.7,13.6-7.2a31.6,31.6,0,0,0,6.9-5.1,1.5,1.5,0,0,0-2.1-2.1c-4.6,4.6-11.1,7.2-16.7,10.2-7.4,3.8-15.1,7.1-22.8,10.3l-16,6.3a95.8,95.8,0,0,1-21.1,5.2,101.4,101.4,0,0,1-14.6,1c-3.5-.1-7.5-.2-10.7-1.8s-3.3,1.7-1.5,2.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M552.9,713.9s15.4,13.5,45.5,7.5l.5-8.3-21.2,2.8C572.3,716.6,552.9,713.9,552.9,713.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M480.3,682.4s14,7.2,22.4,10.5a78,78,0,0,0,17.5,4.3l.4-8A218,218,0,0,1,480.3,682.4Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M685.8,573.4c-2.6,1.4-4.3,4.5-5.6,7.1l-1.8,3.7a6.9,6.9,0,0,0-.5,1.3c-.1.1-.4.9-.2.4-1.4,3.3-2.6,6.7-3.8,10.1-3.8,10.6-7.2,21.4-10.6,32.2-7.9,25.1-15.4,50.4-23.8,75.4-2.8,8.5-6.1,16.7-8.9,25.2-.7,1.8,2.2,2.6,2.8.8,1.3-3.7,2.3-6.5,3.6-9.8s2.8-7.6,4.1-11.4c3.8-11.2,7.3-22.6,10.9-33.9,7.7-24.4,14.9-49,23.2-73.2q2.1-6.3,4.5-12.6c.6-1.5,1.3-3,2-4.5s2.9-6.8,5.6-8.3.2-3.5-1.5-2.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M707,572.9h37a1.5,1.5,0,0,0,0-3H707a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M409.1,750.1c25.2,8.7,50,18.6,74.8,28.3,26.9,10.4,53.7,21,80.8,31,8.6,3.1,19.9,9.2,28,1.7s12.4-13.7,18.3-20.7c7.4-8.9,14.8-18,22-27.1l7.3-9.2c3.2-4.2,7.9-9.3,7.7-14.8s-4.4-6.8-8.2-8.4-9.3-3.4-14-5c-9.2-3.1-18.4-6-27.6-8.9l-1.8-.6c-1.8-.6-2.6,2.3-.8,2.9,6.9,2.1,13.7,4.3,20.5,6.6l15.9,5.3a94,94,0,0,1,10,3.9c7,3.7-.2,12.1-3.2,16q-2.5,3.4-5.4,6.9c-6.8,8.6-13.7,17.1-20.6,25.6s-12.9,15.7-19.8,23c-3,3.1-5.3,5.3-10.1,5.2s-9.2-2.3-13.4-3.9c-25.8-9.3-51.3-19.4-76.9-29.3s-50.6-19.9-76.1-29.1l-6.6-2.3c-1.8-.6-2.6,2.3-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M373.5,707.5c11.1-6.7,21.9-14,32.7-21.2s22.4-15.3,34.1-21.9c-.3.1-.1,0,.1-.1l1.1-.2c2.2-.2,4.3.8,6.4,1.4a23.4,23.4,0,0,0,9.8,1.1c1.9-.2,1.9-3.2,0-3a19.9,19.9,0,0,1-8.4-.8c-3.1-.8-6.4-2.5-9.7-1.3a26.8,26.8,0,0,0-4.9,2.8l-8.1,5.1c-12.6,8.1-25.1,16.5-37.7,24.7-5.6,3.7-11.2,7.4-16.9,10.8-1.6,1-.1,3.6,1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M443,662c12.4-40.1,26.3-79.8,39-119.9,1.5-4.5,2.6-9.3,4.4-13.8a5.8,5.8,0,0,1,6.1-3.8c1.9.2,1.9-2.8,0-3a8.3,8.3,0,0,0-7.7,3.5c-1.6,2.2-2.1,5-2.9,7.5-3.2,10.4-6.6,20.7-9.9,31-6.9,20.9-13.9,41.8-20.7,62.6-3.8,11.7-7.5,23.4-11.2,35.1a1.5,1.5,0,0,0,2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M643.5,697.6h44.3a1.5,1.5,0,0,0,0-3H643.5a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M649.9,680.2H687a1.5,1.5,0,0,0,0-3H649.9a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M750.4,694.6H705.3a1.5,1.5,0,0,0,0,3h45.1a1.5,1.5,0,0,0,0-3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M705.3,680.2h37.8a1.5,1.5,0,0,0,0-3H705.3a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M710,741.6c.1-3,.3-5.9.3-8.9s.4-4.6-.9-6.4-6.9-2.2-9.9-2.1c-5.2.2-10.3.3-15.4.1-1.8-.1-3.6.1-3.5,2.3a40.1,40.1,0,0,1-.1,4.9c0,2.3,0,4.7.1,7v8.4c0,1.9-.1,3.5,1.2,5A7.2,7.2,0,0,0,687,754c2.4.1,4.7,0,7.1,0s7.3.3,10.9,0a5.4,5.4,0,0,0,4.2-2.5c.7-1.2.5-2.7.5-4.1s.3-3.9.3-5.8-2.9-1.9-2.9,0l-.3,4.4a12.8,12.8,0,0,1-.1,1.9,4.5,4.5,0,0,1-.1,2,1.5,1.5,0,0,1-1,.9l-.7.2c-.3.1-.1,0,.1,0-2.8.1-5.5,0-8.2,0h-6.5c-1.8,0-3.9.3-5.6-.6a2,2,0,0,1-.9-.9l-.2-.2V749c-.1-.3,0,.3,0,0a4.8,4.8,0,0,1,0-1.2c0-6.2-.2-12.3,0-18.5a14,14,0,0,0,0-2.9v-.3c.2.2-.4.9-.6,1s-.3.2-.4.1h.4c4,.1,7.9.3,11.8.2s5-.3,7.6-.3,3.1-.1,4.3.7a1.1,1.1,0,0,1,.5.8,18.8,18.8,0,0,1,.1,4.1c0,3-.2,5.9-.2,8.9S710,743.5,710,741.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M890.1,442.9c-83.4,0-151,81-151,180.9s67.6,180.9,151,180.9,151-81,151-180.9S973.5,442.9,890.1,442.9Zm0,345.6c-75.9,0-137.5-73.7-137.5-164.7s61.6-164.7,137.5-164.7,137.5,73.7,137.5,164.7S966,788.5,890.1,788.5Z",
      "fill": "#cac7c8"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M890.1,806.2c-84.1,0-152.5-81.8-152.5-182.4S806,441.4,890.1,441.4s152.5,81.8,152.5,182.4S974.2,806.2,890.1,806.2Zm0-361.8c-82.5,0-149.5,80.5-149.5,179.4s67,179.4,149.5,179.4,149.5-80.5,149.5-179.4S972.5,444.4,890.1,444.4Zm0,345.6c-76.7,0-139-74.5-139-166.2s62.3-166.2,139-166.2,139,74.6,139,166.2S966.7,790,890.1,790Zm0-329.4c-75,0-136,73.2-136,163.2s61,163.2,136,163.2,136-73.2,136-163.2S965.1,460.6,890.1,460.6Z"
    }
  },
  {
    "type": "ellipse",
    "attrs": {
      "cx": "908",
      "cy": "622.7",
      "rx": "15.7",
      "ry": "18.8",
      "fill": "#cac7c8"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M908,643c-9.4,0-17.1-9.1-17.1-20.3s7.7-20.2,17.1-20.2,17.2,9.1,17.2,20.2S917.5,643,908,643Zm0-37.5c-7.8,0-14.1,7.7-14.1,17.2S900.2,640,908,640s14.2-7.8,14.2-17.3S915.9,605.5,908,605.5Z"
    }
  },
  {
    "type": "ellipse",
    "attrs": {
      "cx": "692.9",
      "cy": "787.1",
      "rx": "40.1",
      "ry": "39.7",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M692.9,828.4a41.5,41.5,0,0,1-41.6-41.3c0-22.7,18.7-41.2,41.6-41.2a41.3,41.3,0,1,1,0,82.5Zm0-79.5a38.3,38.3,0,1,0,38.5,38.2A38.4,38.4,0,0,0,692.9,748.9Z"
    }
  },
  {
    "type": "ellipse",
    "attrs": {
      "cx": "696",
      "cy": "784.7",
      "rx": "23.7",
      "ry": "24.7",
      "fill": "#fff"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M696,810.9c-13.9,0-25.2-11.8-25.2-26.2s11.3-26.3,25.2-26.3,25.2,11.8,25.2,26.3S709.9,810.9,696,810.9Zm0-49.5c-12.3,0-22.2,10.4-22.2,23.3s9.9,23.2,22.2,23.2,22.2-10.4,22.2-23.2S708.3,761.4,696,761.4Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M705.9,537.5c9.9,1.2,19.9,1.9,29.9,2.3,4.4.2,8.9.4,13.4.2,2.2-.1,5.2.1,7.3-1.1s.1-3.5-1.6-2.6c-.1.1-.2.2-.7.3l-1.5.2a33.9,33.9,0,0,1-4.5.2c-4.5.1-8.9,0-13.4-.2-9.6-.4-19.3-1.1-28.9-2.3-1.9-.2-1.9,2.8,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M618.6,367.7h56.7a1.5,1.5,0,0,0,0-3H618.6a1.5,1.5,0,0,0,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M812.8,268.2s-2,40.3.3,52.4S810,334,808.3,335s-22.8,16.5-23.9,16.4,23.9-11.6,32.4-11.1l9.9.5s-5.1-19.4-8.6-30S812.8,268.2,812.8,268.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M683.2,309.2s-.6,17.8-5.6,25.8a153.5,153.5,0,0,1-12.8,16.6s18.6-7.7,18.9-14.8S683.2,309.2,683.2,309.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M567.6,343.2s-1.8,13.7-2.8,16.7a37.2,37.2,0,0,1-3.4,6.6s7.5-2,8-3.9S567.6,343.2,567.6,343.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M687.9,720.2s7.4,4.2,12,4.6,0,.6,0,.6l-12.2.2Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M615.1,721.5l-.5,1.8,17.4,5.9,2.3-6.9C631.2,721.8,615.1,721.5,615.1,721.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M648.9,680.9l-5.2,15.3,7.9-1.3C648.5,692.8,648.9,680.9,648.9,680.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M921,425.3v19.6a1.5,1.5,0,0,0,3,0V425.3a1.5,1.5,0,0,0-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M938.1,428.7s-13.4,2-15.4,5.7V424.2l15,1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M917.3,466.7l-8.9,101.8-2.5,29c-.1,1.9,2.8,1.9,3,0l8.9-101.8,2.5-29c.1-1.9-2.9-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M901.3,650.6l-8.8,101.8-2.5,29c-.2,1.9,2.8,1.9,2.9,0l8.9-101.8,2.5-29c.2-1.9-2.8-1.9-3,0Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M764.3,642.1l91.1-10.7,25.9-3.1c1.9-.2,2-3.2,0-3l-91.1,10.8-25.9,3c-1.9.3-1.9,3.2,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M935.9,621.4l57-6.8,21-2.5c1.9-.2,2-3.2,0-3L957,615.9l-21.1,2.5c-1.9.2-1.9,3.2,0,3Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M848.7,477.3c11.9,32.5,23.9,64.8,35.9,97.2,3.4,9.5,6.9,18.9,10.3,28.3.7,1.8,3.6,1.1,2.9-.7-11.8-32.5-23.9-64.8-35.8-97.2l-10.4-28.4c-.6-1.7-3.5-1-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M913.2,652.9l12.1,34.2,19.4,54.5,4.4,12.3c.6,1.8,3.5,1.1,2.9-.8l-12.2-34.2-19.3-54.4-4.4-12.4c-.7-1.8-3.6-1-2.9.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M833.3,765.2q24.2-47.2,48.4-94.6l12.7-24.8c.8-1.7-1.7-3.2-2.6-1.5l-48.3,94.5c-4.3,8.3-8.5,16.6-12.7,24.9-.9,1.7,1.7,3.2,2.5,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M919,596.6l17.4-31.1,27.7-49.2,6.4-11.4a1.5,1.5,0,0,0-2.6-1.5l-17.5,31.1-27.6,49.2-6.4,11.4a1.5,1.5,0,0,0,2.6,1.5Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M799.2,526.4l30,28.1L876.6,599l10.8,10.1c1.4,1.3,3.6-.8,2.2-2.1l-30.1-28.1-47.4-44.5-10.8-10.1c-1.4-1.4-3.5.8-2.1,2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M925.8,646.9c15.3,16.2,30.2,32.9,45.4,49.3l16.4,17.5c1.3,1.4,3.4-.7,2.1-2.1-15.3-16.2-30.2-32.9-45.4-49.3-5.4-5.9-10.9-11.7-16.4-17.5-1.3-1.4-3.4.7-2.1,2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M784,707.4c26.8-18.2,53.9-36.1,80.8-54.1l22.3-15c1.6-1.1.1-3.7-1.5-2.6-26.8,18.2-53.9,36.1-80.8,54.1l-22.3,15c-1.6,1.1-.1,3.6,1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M932.5,607.1c18.5-12.5,37.1-24.8,55.7-37.2l18.8-12.6c1.5-1.1.1-3.7-1.6-2.6-18.5,12.5-37.1,24.8-55.7,37.3-6.3,4.1-12.5,8.3-18.7,12.5-1.6,1.1-.1,3.7,1.5,2.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M771.3,582l37.6,12.1,59.8,19.4,13.7,4.4c1.9.6,2.6-2.3.8-2.9l-37.5-12.1-59.9-19.4-13.7-4.4c-1.8-.6-2.6,2.3-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M934,636.9l26.5,10.3,42.3,16.4,9.6,3.8c1.8.7,2.6-2.2.8-2.9l-26.6-10.3-42.2-16.4-9.6-3.7c-1.8-.7-2.6,2.2-.8,2.8Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M736.5,677.6s5.2,18.1,8.7,18.3a49.6,49.6,0,0,1,6.4.4l-6.5-17.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M747.6,554.5s-9.7,8.7-10,17.2l8.1-.5,4.7-16.7Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M789.9,540.9a114.3,114.3,0,0,1-17.2-1.2,1.5,1.5,0,0,1-1.2-1.7,1.5,1.5,0,0,1,1.7-1.3c.3.1,31.6,5.2,56.3-6.8,11.2-5.5,16.9-16.6,19.7-24.9,4.5-13.3,4.6-29.4.1-38.2a1.7,1.7,0,0,1,.7-2.1,1.6,1.6,0,0,1,2,.7c4.8,9.7,4.9,26.4,0,40.6-2.9,8.8-9,20.6-21.2,26.5C816.9,539.3,801.4,540.9,789.9,540.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M686.9,747.9c-.6.2,15.8-8.1,21.7-6.3l-.4,7.8S700,743.2,686.9,747.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M425.9,663.2c.4-.3,10.3-1.3,17.2-8.9l-2.5,8L422.7,673Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M885.8,384.6s-4.9,5.1,3.3,10.9c5.5,3.7,34.3,5.8,34.3,5.8l-65.8,1.2S883.3,390.4,885.8,384.6Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M224.7,446s22.2,41.1,34,42.6c0,0-26.3,14.2-48.2,20.4,0,0,45.1-10.2,63-19.8l8.6-5.2s-25.3,0-39.2-15.8S224.7,446,224.7,446Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M157.8,691.6c6.8,8.4,13.7,16.6,20.8,24.7,1.3,1.5,3.4-.6,2.1-2.1-7-8.1-14-16.3-20.8-24.7-1.2-1.5-3.3.7-2.1,2.1Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M205,247.9a63.5,63.5,0,0,1,34.4,32.8c.8,1.8,3.3.3,2.6-1.5A66.6,66.6,0,0,0,205.8,245c-1.8-.7-2.6,2.2-.8,2.9Z"
    }
  },
  {
    "type": "path",
    "attrs": {
      "d": "M850.6,508.7l73.9,25.5c1.8.6,2.6-2.3.8-2.9l-73.9-25.5c-1.8-.6-2.6,2.3-.8,2.9Z"
    }
  }
];
